import commonstate from '../constant.js';
import taskTransferUtils from './task_transfer_util.js';
import Utils from '../request_util';
import store from '@/store';
import cloudExploerUtils from "./cloud_exploer_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import Vue from 'vue';
import Router from 'vue-router'
let v = new Vue();
export default {
    commonSnapTaskIconShow: false,
    commonSnapTaskShow: false,
    isflage: true,
    reName: '',
    toItem: null,
    uploadFlag: true,
    editFolderNameBox(nameDom, currentThis, widthLength, inputClass) {
        let inputElement = document.createElement("input");
        inputElement.value = nameDom.children[0].innerHTML;
        currentThis.oldNameValue = nameDom.children[0].innerHTML;
        this.changDivToInput(nameDom, inputElement, widthLength, inputClass);
        nameDom.children[0].id = "nameInput";
        let value = this.getPrefix(nameDom.children[0].value);
        let dom = document.getElementById("nameInput");
        dom.focus();
        dom.selectionStart = 0;
        dom.selectionEnd = value.length;
    },
    changDivToInput(element, inputElement, widthLength, inputClass) {
        element.classList.add("name-edit");
        this.toReplace(inputElement, element.children[0]);
        if (inputClass) {
            element.children[0].classList.add(inputClass);
        }
        element.children[0].parentElement.style.width = widthLength;
        element.children[1].style.display = "block";
    },
    toReplace(newElement, oldElement) {
        oldElement.parentNode.replaceChild(newElement, oldElement);
    },
    changeInputToDiv(element, divElement, addClassName, parentEleWidth) {
        if (addClassName) {
            divElement.classList.add(addClassName);
        }
        if (element != null) {
            this.toReplace(divElement, element.children[0]);
            element.classList.remove("name-edit");
            element.children[0].parentElement.style.width = parentEleWidth;
            element.children[1].style.display = "none";
        }
    },
    //用于定位该菜单显示的位置
    multipleMenuShow(idName, event) { //idName是id名称，event事件
        // 云盘列表界面改版时优化
        if (idName == 'editHomeMenus') {
            let widthNavEle = document.getElementsByClassName('widthNav2');
            let isWidthNav = widthNavEle.length > 0;
            let menu = document.getElementById(idName);
            let offsetX = isWidthNav ? 583 : 283;
            let offsetY = 91;
            let x = event.clientX - offsetX;
            let y = event.clientY - offsetY;
            if (event.clientX + 300 > window.innerWidth) {
                let locale = widthNavEle[0].getAttribute('locale');
                if (locale == 'deutsch') {
                    x = x - 189;
                } else if (locale == 'france') {
                    x = x - 142;
                } else if (locale == 'portuguese') {
                    x = x - 204;
                } else if (locale == 'spanish') {
                    x = x - 184;
                } else if (locale == 'italian') {
                    x = x - 184;
                } else if (locale == 'nederlands') {
                    x = x - 194;
                } else if (locale == 'japanese') {
                    x = x - 143;
                } else if (locale == 'traditionalChinese') {
                    x = x - 128;
                } else if (locale == 'chinese') {
                    x = x - 128;
                } else {
                    x = x - 137;
                }
            }
            if (event.clientY + 140 > window.innerHeight) {
                y = y - 140;
            }
            menu.style.left = x + "px";
            menu.style.top = y + "px";
            return;
        }
        if (idName == 'editDrivesMenus') {
            let menu = document.getElementById(idName);
            let x = event.clientX;
            let y = event.clientY;
            if (event.clientX + 160 > 550) {
                x = x - 160;
            }
            if (event.clientY + 140 > window.innerHeight) {
                y = y - 140;
            }
            menu.style.left = x + "px";
            menu.style.top = y + "px";
            return;
        }
        if (idName == 'rightMenu') {
            let menu = document.getElementById(idName);
            let x = event.clientX - 560;
            let y = event.clientY - 90;
            if (event.clientX + 160 > window.innerWidth) {
                x = x - 160;
            }
            if (event.clientY + 205 > window.innerHeight) {
                y = y - 205;
            }
            menu.style.left = x + "px";
            menu.style.top = y + "px";
            return;
        }
        // 以前的逻辑
        let menu = document.getElementById(idName); //通过id获取该菜单
        let allWidth = document.body.offsetWidth; //获取对象的可见宽度，包滚动条等边线，会随窗口的显示大小改变。
        let allHeight;
        allHeight = document.body.offsetHeight; //获取对象的可见高度，包滚动条等边线，会随窗口的显示大小改变。
        if (idName == 'editHomeMenus') {
            allHeight = document.getElementById('homeBox').offsetHeight;
        }
        let rightedge = allWidth - event.clientX; //返回当事件被触发时鼠标指针向对于浏览器页面（或客户区）的水平坐标
        let bottomedge = allHeight - event.clientY; //返回当事件被触发时鼠标指针向对于浏览器页面（或客户区）的竖直坐标
        /*如果从鼠标位置到容器右边的空间小于菜单的宽度，就定位菜单的左坐标（Left）为当前鼠标位置向左一个菜单宽度*/
        if (menu) {
            if (rightedge < menu.offsetWidth) {
                menu.style.left = event.clientX - menu.offsetWidth - 260 + "px";
                if (idName == 'sharePageRightMenu') {
                    menu.style.left = event.clientX - menu.offsetWidth + "px";
                }
                if (idName == 'editHomeMenus') {
                    menu.style.left = event.clientX - menu.offsetWidth - 310 + "px";
                }

            } else {
                /*否则，就定位菜单的左坐标为当前鼠标位置*/
                menu.style.left = event.clientX - 260 + "px";
                if (idName == 'editDrivesMenus' || idName == 'sharePageRightMenu') {
                    menu.style.left = event.clientX + "px";
                }
                if (idName == 'editHomeMenus') {
                    menu.style.left = event.clientX - 310 + "px";
                }
            }
            /*如果从鼠标位置到容器下边的空间小于菜单的高度，就定位菜单的上坐标（Top）为当前鼠标位置向上一个菜单高度*/
            if (bottomedge < menu.offsetHeight) {
                menu.style.top = event.clientY - menu.offsetHeight - 90 + "px";
                if (idName == 'editDrivesMenus' || idName == 'sharePageRightMenu') {
                    menu.style.top = event.clientY - menu.offsetHeight + 10 + "px";
                }
                if (idName == 'searchMenu') {
                    menu.style.top = event.clientY - menu.offsetHeight + "px";
                }
                if (idName == 'editHomeMenus') {
                    menu.style.top = event.clientY - menu.offsetHeight - 190 + "px";
                }
            } else {
                /*否则，就定位菜单的上坐标为当前鼠标位置*/
                menu.style.top = event.clientY - 90 + "px";
                if (idName == 'editDrivesMenus' || idName == 'sharePageRightMenu') {
                    menu.style.top = event.clientY + "px";
                }
                if (idName == 'searchMenu') {
                    /*否则，就定位菜单的上坐标为当前鼠标位置*/
                    menu.style.top = event.clientY - 85 + "px";
                }
                if (idName == 'editHomeMenus') {
                    menu.style.top = event.clientY - 180 + "px";
                }
            }
        }
    },
    matchfileTypes(fileName) {
        let index = fileName.lastIndexOf(".");
        let suffix;
        if (index > -1) {
            suffix = fileName.substring(index + 1).toLowerCase();
            if (commonstate.zipList.includes(suffix)) {
                suffix = 'zip';
            } else if (commonstate.wordList.includes(suffix)) {
                suffix = 'doc';
            } else if (commonstate.exceList.includes(suffix)) {
                suffix = 'xls';
            } else if (commonstate.pptList.includes(suffix)) {
                suffix = 'ppt';
            } else if (commonstate.htmlList.includes(suffix)) {
                suffix = 'html';
            } else if (commonstate.imgList.includes(suffix)) {
                suffix = 'img';
            } else if (commonstate.rawList.includes(suffix)) {
                suffix = 'raw';
            } else if (commonstate.cdaList.includes(suffix)) {
                suffix = 'cda';
            } else if (commonstate.movLsit.includes(suffix)) {
                suffix = 'mov';
            } else if (commonstate.pdfList.includes(suffix)) {
                suffix = 'pdf';
            } else if (commonstate.psdList.includes(suffix)) {
                suffix = 'psd';
            } else if (commonstate.aiList.includes(suffix)) {
                suffix = 'ai';
            } else if (commonstate.aeList.includes(suffix)) {
                suffix = 'ae';
            } else if (commonstate.cadList.includes(suffix)) {
                suffix = 'cad';
            } else if (commonstate.ttfList.includes(suffix)) {
                suffix = 'ttf';
            } else if (commonstate.isoList.includes(suffix)) {
                suffix = 'iso';
            } else if (suffix == 'ink' || suffix == 'ddl' || suffix == 'txt' || suffix == 'exe' || suffix == 'multcloud') {
                suffix = suffix;
            } else {
                suffix = 'other';
            }
        } else {
            suffix = 'other';
        }
        return suffix;
    },
    matchExtension(extionName) {
        let extion = extionName.trim();
        let suffix;
        if (extion) {
            let index = extion.lastIndexOf(".");
            if (index > -1) {
                suffix = extion;
            } else {
                suffix = '.' + extion;
            }
        }
        return suffix;
    },
    getSuffix(fileName) {
        let index = fileName.lastIndexOf(".");
        let suffix;
        if (index > -1) {
            suffix = fileName.substring(index + 1);
        } else {
            suffix = '';
        }
        return suffix;
    },
    getPrefix(fileName) {
        let index = fileName.lastIndexOf(".");
        let prefix;
        if (index > -1) {
            prefix = fileName.substring(0, index);
        } else {
            prefix = fileName;
        }
        return prefix;
    },
    substringType(name) {
        let index = name.indexOf("=");
        let type;
        if (index > -1) {
            type = name.substring(index + 1);
        } else {
            type = name;
        }
        return type;
    },
    isAllEqual(array) {
        if (array.length > 0) {
            return !array.some(function (value, index) {
                return value !== array[0];
            });
        } else {
            return true;
        }
    },
    createDownloadForm(downloadId) {
        var $eleForm = $("<form method='Get'></form>");
        var url = commonstate.apiUrl + "/files/" + downloadId + "/content";
        $eleForm.attr("action", url);
        $(document.body).append($eleForm);
        return $eleForm;
    },
    createDownloadFormEmail(downloadId) {
        var $eleForm = $("<form method='Get'></form>");
        var url = commonstate.apiUrl + "/cloud_email/" + downloadId + "/content";
        $eleForm.attr("action", url);
        $(document.body).append($eleForm);
        return $eleForm;
    },
    //视频下载模块下载
    createDownloadFormVideosaver(url) {
        var $eleForm = $("<form method='Get'></form>");
        // var url = commonstate.apiUrl + "/extensions/video_saver/download";
        $eleForm.attr("action", url);
        $(document.body).append($eleForm);
        return $eleForm;
    },
    createPreviewLinkForm(downloadId) {
        var previewurl = commonstate.previewApiwUrl + "/files/" + downloadId + "/content";
        return previewurl;
    },
    sortArr(dataJson, upShow, index) {
        //0文件名 1表示size 2表示Date
        let list = [];
        let fileJson = [];
        let folderJson = [];
        for (let i = 0; i < dataJson.length; i++) {
            if (dataJson[i].dir) {
                folderJson.push(dataJson[i])
            } else {
                fileJson.push(dataJson[i]);
            }
        }
        if (index == 0) {
            fileJson = this.sortJsonArrName(fileJson, upShow);
            folderJson = this.sortJsonArrName(folderJson, upShow);
            list = folderJson.concat(fileJson);
        }
        if (index == 1) {
            let folderJsonSort = [];
            fileJson = this.sortJsonArrSize(fileJson, upShow);
            folderJsonSort = this.sortJsonArrSize(folderJson, upShow);
            if (folderJsonSort && folderJsonSort.length) {
                list = folderJsonSort.concat(fileJson);
            } else {
                list = folderJson.concat(fileJson);
            }
        }
        if (index == 2) {
            let folderJsonSort = [];
            fileJson = this.sortJsonArrTime(fileJson, upShow);
            folderJsonSort = this.sortJsonArrTime(folderJson, upShow);
            if (folderJsonSort && folderJsonSort.length) {
                list = folderJsonSort.concat(fileJson);
            } else {
                list = folderJson.concat(fileJson);
            }
        }
        if (index == 3) {
            let folderJsonSort = [];
            fileJson = this.sortJsonArrType(fileJson, upShow);
            folderJsonSort = this.sortJsonArrType(folderJson, upShow);
            if (folderJsonSort && folderJsonSort.length) {
                list = folderJsonSort.concat(fileJson);
            } else {
                list = folderJson.concat(fileJson);
            }
        }
        if (index == 4) {
            let folderJsonSort = [];
            fileJson = this.sortJsonArrDate(fileJson, upShow);
            folderJsonSort = this.sortJsonArrDate(folderJson, upShow);
            if (folderJsonSort && folderJsonSort.length) {
                list = folderJsonSort.concat(fileJson);
            } else {
                list = folderJson.concat(fileJson);
            }
        }
        return list;
    },
    sortArrEmail(dataJson, upShow, index){
        //outlook用，文件夹名称排序，邮件日期排序
        //0文件名 1表示size 2表示Date
        let list = [];
        let emailJson = [];
        let folderJson = [];
        for (let i = 0; i < dataJson.length; i++) {
            if (dataJson[i].docType&&dataJson[i].docType=="thread") {
                emailJson.push(dataJson[i])
            } else {
                folderJson.push(dataJson[i]);
            }
        }
        if (index == 0) {
            let folderJsonSort = [];
            folderJsonSort = this.sortJsonArrName(folderJson, upShow);
            emailJson = this.sortJsonArrDate(emailJson, upShow);
            if (folderJsonSort && folderJsonSort.length) {
                list = folderJsonSort.concat(emailJson);
            } else {
                list = folderJson.concat(emailJson);
            }
        }
        return list;
    },
    sortJsonArrTime(dataJson, upShow) {
        dataJson.sort(
            function (a, b) {
                let result;
                if (a.modifiedTime && b.modifiedTime) {
                    if (upShow) {
                        result = a.modifiedTime - b.modifiedTime;
                    } else {
                        result = (b.modifiedTime - a.modifiedTime);
                    }
                }
                return result;
            }
        );
        return dataJson;
    },
    sortJsonArrDate(dataJson, upShow) {
        dataJson.sort(
            function(a, b) {
                let result;
                if (a.date && b.date) {
                    let aDate = new Date(a.date).getTime();
                    let bDate = new Date(b.date).getTime();
                    if (upShow) {
                        result = aDate - bDate;
                    } else {
                        result = (bDate - aDate);
                    }
                }
                return result;
            }
        );
        return dataJson;
    },
    containsNumber(str) {
        var reg = /\d/;
        return reg.test(str);
    },
    haveContainsNumber(str) {
        return !!str.match(/\d/g);
    },
    sortJsonArrName(dataJson, upShow) {
        let chars = [];
        $.each(dataJson, function (i, item) {
            chars.push(item); // 字母
        });
        chars.sort(
            function (a, b) {
                let result;
                if (upShow) {
                    result = a.name.localeCompare(b.name, 'zh-CN', { numeric: true });
                } else {
                    result = -a.name.localeCompare(b.name, 'zh-CN', { numeric: true });
                }
                return result;
            }
        );
        return chars;
    },
    sortDriveName(dataJson) {
        return dataJson;
    },
    sortJsonArrSize(dataJson, upShow) {
        let resultArr = [];
        let noneArr = [];//size为空的文件夹集合
        $.each(dataJson, function (i, item) {
            if (item.size || item.size == 0) {
                resultArr.push(item);
            } else {
                noneArr.push(item);
            }
        });
        resultArr.sort(
            function (a, b) {
                let result;
                if (upShow) {
                    result = a.size - b.size;
                } else {
                    result = (b.size - a.size);
                }
                return result;
            }
        );
        resultArr = noneArr.concat(resultArr)
        return resultArr;
    },
    sortJsonArrType(dataJson, upShow) {
        let resultArr = [];
        $.each(dataJson, function (i, item) {
            if (item.type) {
                resultArr.push(item);
            }
        });
        resultArr.sort(
            function (a, b) {
                let result;
                if (upShow) {
                    result = a.type - b.type;
                } else {
                    result = (b.type - a.type);
                }
                return result;
            }
        );
        return resultArr;
    },
    sort(a, b) {
        var n = !isNaN(a - 0),
            n2 = !isNaN(b - 0);
        // 数字优先
        if (n && n2) {
            return a - b;
        } else if (n) {
            return -1;
        } else if (n2) {
            return 1;
        }
        // 将含有汉字的使用localeCompare排序
        var e = escape(a).indexOf("%u") > -1,
            e2 = escape(b).indexOf("%u") > -1
        if (e && e2) {
            return a.localeCompare(b);
        } else if (e) {
            return 1;
        } else if (e2) {
            return -1;
        }
        return a.localeCompare(b);
    },
    packageData(dataJson, driveId, pid, transferFromOpen, cloudType) {
        let jsonArr = [];
        for (let i = 0; i < dataJson.length; i++) {
            if (transferFromOpen) {
                dataJson[i].driveId = driveId;
                dataJson[i].pid = pid;
                dataJson[i].driveType = cloudType;
                jsonArr.push(dataJson[i]);
            } else if (dataJson[i].dir) {
                dataJson[i].driveId = driveId;
                dataJson[i].pid = pid;
                dataJson[i].driveType = cloudType;
                jsonArr.push(dataJson[i]);
            }
        }
        return jsonArr;
    },
    packageDataChildren(dataJson) {
        let jsonArr = [];
        for (let i = 0; i < dataJson.length; i++) {
            if (dataJson[i].dir) {
                jsonArr.push(dataJson[i]);
            }
        }
        return jsonArr;
    },
    getCatalog(item) {
        let catelog = "";
        if (!item) {
            return catelog;
        }
        let nodesArr = item;
        for (let i = nodesArr.length - 1; i >= 0; i--) {
            if (catelog) {
                if (nodesArr[i].fileName) {
                    catelog = catelog + '\\' + nodesArr[i].fileName;
                } else if (nodesArr[i].filename) {
                    catelog = catelog + '\\' + nodesArr[i].filename;
                } else {
                    catelog = catelog + '\\' + nodesArr[i].name;
                }
            } else {
                if (nodesArr[i].fileName) {
                    catelog = nodesArr[i].fileName;
                } else if (nodesArr[i].filename) {
                    catelog = nodesArr[i].filename;
                } else {
                    catelog = nodesArr[i].name;
                }
            }
        }
        return catelog;
    },
    getNowDateFormat() {
        var date = new Date();
        let Y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let H = date.getHours();
        let i = date.getMinutes();
        let s = date.getSeconds();
        if (m < 10) {
            m = '0' + m;
        }
        if (d < 10) {
            d = '0' + d;
        }
        if (H < 10) {
            H = '0' + H;
        }
        if (i < 10) {
            i = '0' + i;
        }
        if (s < 10) {
            s = '0' + s;
        }
        var t = Y + '-' + m + '-' + d + ' ' + H + ':' + i + ':' + s;
        return t;
    },
    getQueryJSON() { //将url中"?"符后的字串转成json
        var url = window.location.href; //获取url中"?"符后的字串
        var idex = url.indexOf("?");
        if (idex == -1) return null;
        var str = url.substring(idex + 1);
        var strs = str.split("&");
        var theQquery = new Object();
        for (var i = 0; i < strs.length; i++) {
            var queryStr = strs[i].split("=");
            theQquery[queryStr[0]] = unescape(queryStr[1]);
        }
        return theQquery;
    },
    switchToPay() {
        let direction = window.vm.$children[0].$refs.routerView.$refs.routView;
        // var timerExpired = this.getTimerExpired(commonstate.activityEndedTimer);
        // if (timerExpired) {
        //     direction.$router.push('/mc_project/paySysActivity');
        // } else {
            direction.$router.push('/mc_project/paySys');
        // }
    },
    judgeRepeatTaskName(allTasklistData, direction) {
        if (direction.$store.state.isLiteMode) {
            let tasks = direction.$store.state.tasks;
            let j = tasks.length + 1;
            let taskTxt = this.getTaskTxt(direction);
            let name = taskTxt + ' ' + j;
            for (let i = 0; i < tasks.length; i++) {
                if (tasks[i].name == name) {
                    j = j + 1;
                    name = taskTxt + ' ' + j;
                    i = -1;
                    continue;
                }
            }
            return name;
        } else {
            let j = allTasklistData.length + 1;
            let taskTxt = this.getTaskTxt(direction);
            let name = taskTxt + ' ' + j;
            for (let i = 0; i < allTasklistData.length; i++) {
                if (allTasklistData[i].name == name) {
                    j = j + 1;
                    name = taskTxt + ' ' + j;
                    i = -1;
                    continue;
                }
            }
            return name;
        }
    },
    getTaskTxt(direction) {
        let result;
        if (direction.$i18n.locale == 'english') {
            result = 'Task';
        }
        if (direction.$i18n.locale == 'deutsch') {
            result = 'Aufgabe';
        }
        if (direction.$i18n.locale == 'france') {
            result = 'Tâche';
        }
        if (direction.$i18n.locale == 'portuguese') {
            result = 'Tarefa';
        }
        if (direction.$i18n.locale == 'japanese') {
            result = 'タスク';
        }
        if (direction.$i18n.locale == 'traditionalChinese') {
            result = '任務';
        }
        if (direction.$i18n.locale == 'chinese') {
            result = '任务';
        }
        if (direction.$i18n.locale == 'spanish') {
            result = 'tarea';
        }
        if (direction.$i18n.locale == 'italian') {
            result = 'compito';
        }
        if (direction.$i18n.locale == 'nederlands') {
            result = 'Taak';
        }
        return result;
    },
    isVip() {
        let flag;
        let user = this.getUser();
        flag = user.vip;
        return flag;
    },
    sizeUtil(size) {
        var quantity;
        var measureUnit;
        if (size < 0) {
            quantity = 0;
            measureUnit = " bytes";
        } else if (size < (2 << 9)) {
            quantity = size;
            measureUnit = " bytes";
        } else if (size < (2 << 19)) {
            quantity = size / (2 << 9);
            measureUnit = " KB";
        } else if (size < (2 << 29)) {
            quantity = size / (2 << 19);
            measureUnit = " MB";
        } else {
            quantity = size / (2 << 29);
            if (quantity < (2 << 9)) {
                measureUnit = " GB";
            } else {
                quantity = quantity / (2 << 9);
                measureUnit = " TB";
            }
        }
        quantity = Math.floor(quantity * 100) / 100
        return quantity + measureUnit;
    },
    transferTime: function (cTime) {
        if (!cTime) return '';
        var dt = new Date(cTime);
        var m = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Spt", "Oct", "Nov", "Dec");
        let mn = dt.getMonth();
        let dn = dt.getDate();
        let hh = dt.getHours();
        let mm = dt.getMinutes();
        if (hh < 10) {
            hh = '0' + hh;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        let newDate = m[mn] + " " + dn + " " + dt.getFullYear() + "  " + hh + ":" + mm;
        return newDate;
    },
    //将数字类型的时间转换为英文格式
    transferForMatTime: function (cTime) {
        if (!cTime) return '';
        var date = new Date(cTime);
        let year = date.getFullYear();
        let Month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (Month >= 1 && Month <= 9) {
            Month = "0" + Month;
        }
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }
        if (hour >= 0 && hour <= 9) {
            hour = "0" + hour;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
            seconds = "0" + seconds;
        }
        let dateStr = year + '-' + Month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
        return dateStr;
    },
    getLocaleTo(language) {
        switch (language) {
            case 'deutsch':
                return "de-DE";
            case 'france':
                return "fr-FR";
            case 'portuguese':
                return "pt-PT";
            case 'japanese':
                return "ja-JP";
            case 'traditionalChinese':
                return "zh-TW";
            case 'chinese':
                return "zh-CN";
            case 'spanish':
                return "es-ES";
            case 'italian':
                return "it-IT";
            case 'nederlands':
                return "nl-NL";
            default:
                return "en-US";
        }
    },
    //和前端的首页进行匹配然后改变样式
    getLocaleToIndex(language) {
        switch (language) {
            case 'deutsch':
                return "de";
            case 'france':
                return "fr";
            case 'portuguese':
                return "pt";
            case 'japanese':
                return "jp";
            case 'traditionalChinese':
                return "tw";
            case 'chinese':
                return "cn";
            case 'spanish':
                return "es";
            case 'italian':
                return "it";
            case 'nederlands':
                return "nl";
            default:
                return 'en';
        }
    },
    caseIndexLanguage(language) {
        switch (language) {
            case 'deutsch':
                return "de";
            case 'france':
                return "fr";
            case 'portuguese':
                return "pt";
            case 'japanese':
                return "jp";
            case 'traditionalChinese':
                return "tw";
            case 'chinese':
                return "cn";
            case 'english':
                return '';
            case 'italian':
                return 'it';
            case 'spanish':
                return 'es';
            case 'nederlands':
                return "nl";
            default:
                return 'en';
        }
    },
    //获取当前语言的所属货币编号
    getPriceForLange(language) {
        switch (language) {
            case 'deutsch':
                return "ECU";
            case 'france':
                return "ECU";
            case 'portuguese':
                return "BRL";
            case 'japanese':
                return "JPY";
            case 'traditionalChinese':
                return "TWD";
            case 'chinese':
                return "CNY";
            case 'spanish':
                return "ECU";
            case 'italian':
                return "ECU";
            case 'nederlands':
                return "ECU";
            default:
                return 'USD';
        }
    },
    checkNode(model, sourceItem) {
        let flag;
        if (model.id == sourceItem.id && model.driveId == sourceItem.driveId) {
            flag = true;
            return flag;
        }
        if (model.pnode) {
            this.checkNode(model.pnode, sourceItem);
        }
    },
    allotDetailedProgrssData() {
        if (window.vm && window.vm.$children) {//修改detail progress分配数据逻辑，减少dom操作
            //获取当前界面的vue值
            const direction = window.vm.$children[0].$refs.routerView.$refs.routView;
            // //将数据存在localStorage
            let allData = store.state.detailedProgrssData;
            store.state.detailTabSuccess = [];
            store.state.detailTabUnfinished = [];
            let tabSuccess = store.state.detailTabSuccess;
            let taUnfinish = store.state.detailTabUnfinished;
            let unfinishedArr = [];
            $.each(allData, function (index, detailItem) {
                if (detailItem.status >= 4 && !detailItem.errorList.length) {
                    tabSuccess.push(detailItem);
                } else if (detailItem.status == 3 || detailItem.status >= 4 && detailItem.errorList.length) {
                    taUnfinish.push(detailItem);
                } else if (detailItem.status < 3 || detailItem.status == 'ready' || (detailItem.itemProgressInfo && detailItem.itemProgressInfo.status == 'ready')) {
                    unfinishedArr.push(detailItem);
                    let Base64 = require('js-base64').Base64;
                    localStorage.setItem("detailedProgrssData", Base64.encode(JSON.stringify(unfinishedArr)));
                }
            });
            if (direction.$refs.detailedProgrss && direction.$refs.detailedProgrss.$refs.tab1.clickCurrent == -1) {
                direction.$refs.detailedProgrss.$refs.tab1.clickCurrent = 0;
            }
        }
    },
    //开始获取临时任务的进度
    runDetailProgressData(direction) {
        let that = this;
        direction.$store.state.loadFlag = false; //一有任务运行就防止其他任务的进入，只加载在临时任务列表里的任务
        let requestUrl;
        let moveData; //发送请求的数据
        //获取系统中的所有临时任务
        let allData = store.state.retryItems;
        store.state.notUploadFile = true;
        let snapUser = this.getUser();
        if (allData && allData.length && allData[0]) {
            if (!allData[0].cutData) { //若是跨云盘操作则获取进度
                if (allData[0].taskId) {
                    let getProData = {
                        ud: snapUser.id,
                        type: 4,
                        wd: allData[0].taskId,
                    }
                    let t = setTimeout(() => {
                        if (allData[0] && allData[0].name) {
                            that.getCrossProgress(getProData, allData[0].name, direction);
                        }
                        clearTimeout(t);
                    }, 2000);
                }
            } else {
                //若是同云盘操作 则判断是copy还是cut，然后再调用接口
                if (direction.$refs.snapTaskDialog) {
                    direction.$refs.snapTaskDialog.crossFlag = false;
                }
                if (allData[0].operate == 'copy') {
                    requestUrl = "/files/" + "copy";
                } else if (allData[0].operate == 'cut') {
                    requestUrl = "/files/" + "move";
                }
                moveData = allData[0].cutData;
                delete moveData.s;//调用粘贴接口
                this.startPasteQuest(moveData, allData[0].name, direction, requestUrl);
            }
        } else { //若执行完毕没有数据了
            store.state.loadFlag = true;
            if (store.state.cutArr && store.state.cutArr.length) {
                store.state.cutArr = [];
            }
        }
        direction.snapTaskIconShow = true;
        that.commonSnapTaskIconShow = true;
        that.commonSnapTaskShow = true;
        if (direction.$refs.snapTaskDialog && direction.$store.state.snapTaskShow) {
            direction.$store.state.snapTaskShow = true;
        }
    },
    //随机生成ID
    randomRangeId(num) {
        var returnStr = "",
            charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < num; i++) {
            var index = Math.round(Math.random() * (charStr.length - 1));
            returnStr += charStr.substring(index, index + 1);
        }
        return returnStr;
    },
    //同云盘的数据则进行复制粘贴、剪切粘贴操作
    startPasteQuest(moveData, name, direction, requestUrl) {
        //查询目标云盘中是否有重复名称，如果有则进行重命名
        let listData = {
            id: moveData.tid,
            ud: moveData.ud,
            dd: moveData.dd
        }
        let nameArr = [];
        let key = listData.id + listData.dd;//获取缓存中的数据
        let tableData = direction.$store.state.cacheTableDatas[key];
        if (tableData) {//把该界面的名称都放入桌面数组
            let tableDatas = tableData.tableData;
            for (let i = 0; i < tableDatas.length; i++) {
                nameArr.push(tableDatas[i].name);
            }
        } else {//如果没有缓存数据，则遍历该目录的文件名，放入数组
            Utils.doFilesRequest("list", listData).then(res => {
                for (let i = 0; i < res.items.length; i++) {
                    nameArr.push(res.items[i].name);
                }
            });
        }//判断是否有重命文件，如果有则进行重命名
        this.pasteIncludesFileName(nameArr, moveData.n, this);
        moveData.n = this.reName;//进行粘贴请求
        this.pasteFileRequestCallBack(moveData, name, direction, requestUrl);
    },
    pasteFileRequestCallBack(moveData, name, direction, requestUrl) {
        let selectItemArr = direction.selectItemArr;
        let that = this;
        let t = setTimeout(function () {
            clearTimeout(t);
            direction.selectItemArr = selectItemArr;//执行粘贴请求
            that.pasteFileRequest(moveData, name, direction, requestUrl, function (res) {
                let t1 = setTimeout(function () {//当后端返回请求，隔0.7S执行以下操作
                    if (!store.state.retryItems.length) {//如果待执行长度为空，则进行重置数据
                        direction.$refs.snapTaskDialog.transferFlag = true;
                        store.state.retryItems = [];
                        store.state.tId = null;
                        direction.currentIndex = -1;
                        store.commit("setTId", null);
                        store.commit("setSourceDriveId", null);
                        store.commit("setCutArr", []);
                        store.commit("setCopyArr", []);
                    }
                    clearTimeout(t1);
                }, 700);
            });
        }, 800);
    },//刷新粘贴剪切目录数据，调用这个借口是同云盘
    toCopyCutItemDataRefresh(callback) {
        let cutData;
        let toDriveType;
        if (store.state.retryItems[0] && store.state.retryItems[0].cutData) {
            cutData = store.state.retryItems[0].cutData;
            toDriveType = store.state.retryItems[0].toDriveType;//调用这个借口是同云盘，源目录等于目标目录
        }
        if (cutData.tid) {//刷新粘贴目标目录数据
            let listData = new cloudExploerUtils.filelistData(cutData.tid, this.getUser().id, cutData.dd);
            this.toCopyCutItemDataRefreshRequest(listData, toDriveType, function (res) {
                callback(res);
            });
        }
        if (store.state.retryItems[0] && store.state.retryItems[0].operate == 'cut') {//如果是剪切操作，则还需要刷新源目录
            let listDataSource = new cloudExploerUtils.filelistData(cutData.pid, this.getUser().id, cutData.dd);
            this.toCopyCutItemDataRefreshRequest(listDataSource, toDriveType, function (res) {

            });
        }
    },
    toCopyCutItemDataRefreshRequest(listData, toDriveType, callback) {
        var clouds;
        let that = this;
        Utils.doFilesRequest("list", listData).then(res => {//遍历出该目录数据
            if (res.status == 200) {
                if (res.items) {
                    for (let i = 0; i < res.items.length; i++) {
                        res.items[i].driveType = toDriveType;
                        res.items[i].pid = listData.id;
                        res.items[i].driveId = listData.dd;
                    }
                    //将新增的数据封装到树形组件
                    if (store.getters.getUsersDrives.length) {
                        clouds = store.getters.getUsersDrives;
                        //封装新数据
                        var packageDatas = that.packageData(that.sortArr(res.items, true, 0), listData.dd, listData.id,
                            store.state.transferFromOpen, toDriveType);
                        for (let j = 0; j < clouds.length; j++) {
                            if (clouds[j].driveInfo.id == listData.dd) {
                                if (clouds[j].driveInfo.rootId == listData.id) {
                                    //找到改数据应该在的位置并赋值
                                    clouds[j].children = packageDatas;
                                } else if (clouds[j].children) {
                                    that.getFileChildren(clouds[j].children, packageDatas, listData.id);
                                }
                            }
                        }
                    }
                }
                store.commit("setCacheTableDatas", {
                    id: listData.id + listData.dd,
                    tableData: res.items
                });
            }
            callback(res);
        });
    },//粘贴接口浏览器给进度效果
    pasteFileRequest(moveData, name, direction, requestUrl, callback) {
        let that = this;
        let config = {
            onUploadProgress: function (e) {
                //如果lengthComputable为false，就获取不到e.total和e.loaded
                if (e.lengthComputable) {
                    var rate = e.loaded / e.total;
                }
            }
        }

        Utils.doProgressRequest(requestUrl, moveData, config, function (res) {

            if (res.status >= 400) {
                $.each(store.state.retryItems, function (index, item) {
                    //如果响应失败，给失败标记
                    if (item.name == name) {
                        item.status = 'failed';
                        if (res.status == 401) {
                            direction.$toast({
                                text: direction.$t('language.exception.' + res.reason),
                                type: 'fail',
                                idValue: "rightBo",
                            });
                        } else {
                            direction.$toast({
                                text: item.name + '    failed',
                                type: 'fail',
                                idValue: "rightBo"
                            });
                        }
                        store.state.retryItems.splice(index, 1);
                        that.runDetailProgressData(direction);
                        return false;
                    }
                });
            } else {//如果成功给成功效果
                that.pasteSuccess(name, direction);
            }
            callback(res);
        });
    },
    //格式化字节 向下取整
    formatByte: function (bytes) {
        if (bytes == 0) { return 0 + 'Bytes'; } else if (!bytes) {
            return '';
        }
        if (bytes == -1) {
            return "Unlimited";
        } else if (bytes < 1024) {
            return Math.ceil(Math.round(bytes)) + "Bytes";
        } else if (bytes < 1024 * 1024) {
            return Math.round(bytes / 1024 * 100) / 100 + "KB";
        } else if (bytes < 1024 * 1024 * 1024) {
            return Math.round(bytes / 1024 / 1024 * 100) / 100 + "MB";
        } else if (bytes < 1024 * 1024 * 1024 * 1024) {
            return Math.round(bytes / 1024 / 1024 / 1024 * 100) / 100 + "GB";
        } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024) {
            return Math.round(bytes / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "TB";
        } else if (bytes < 1024 * 1024 * 1024 * 1024 * 1024 * 1024) {
            return Math.round(bytes / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "PB";
        } else {
            return Math.round(bytes / 1024 / 1024 / 1024 / 1024 / 1024 / 1024 * 100) / 100 + "EB";
        }
    },
    pasteSuccess(name, direction) {
        let that = this;
        $.each(direction.$store.state.retryItems, function (index, item) {
            //成功响应,进度设为100%
            if (item.name == name) {//刷新目录数据
                item.percent = 100;
                if (direction.$refs.snapTaskDialog) {
                    direction.$refs.snapTaskDialog.$forceUpdate();
                }
                that.toCopyCutItemDataRefresh(function (res) {
                    let t = setTimeout(() => {
                        direction.rightMenuShow = false;
                        direction.$store.state.retryItems.splice(index, 1);
                        that.runDetailProgressData(direction);//执行下一个进度数据
                        clearTimeout(t);
                    }, 2000);
                });
                return false;
            }
        });
    },
    //保存复制或剪切信息，对team云盘则添加权限和标识
    //可以取消该功能，测试任务是否可以进行云盘验证，将team转化为正常云盘进行操作，使用sub判断是否是team，任务信息保留permissionId
    setCopyOrCut(isCopy, data, folderId, direction) {
        let that = this;
        //如果复制或者剪切的信息是team的，则添加权限和标识
        if (data.length > 0 && data[0].driveType == "team") {
            $.each(data, function (index, item) {
                item.permissionId = folderId.substring(0, 32);
                item.way = "sub";
            })
        }
        that.setCopyOrCutToStore(isCopy, data, folderId, direction)
    },
    setCopyOrCutToStore(isCopy, data, folderId, direction) {
        if (isCopy) {
            //将数据放入复制数组
            direction.$store.commit("setCopyArr", Object.assign([], data));
            //清空剪切数据
            direction.$store.commit("setCutArr", []);
            direction.$store.commit("setCopyFolderId", folderId);
        } else {
            //将数据放入剪切数组
            direction.$store.commit("setCutArr", data);
            direction.$store.state.cutClonArr = Object.assign([], data);
            //清空复制数组
            direction.$store.commit("setCopyArr", []);
            direction.$store.commit("setCutFolderId", folderId);
        }
    },
    calculationPercent(transferInfo) {
        let percent;
        let fileCountPercent;
        if (transferInfo&&transferInfo.nextCount) {//如果返回了nextCount，任务进度以fileCountPercent为准
            fileCountPercent = transferInfo.nextCount / transferInfo.totalFileCount;
        } else {
            fileCountPercent = 0;
        }
        if (transferInfo&&transferInfo.totalFileCount <= 2) {//如果totalFileCount的数量小于2，则任务进度以readedBytes为准
            if (transferInfo.totalReadedBytes || transferInfo.totalBytes) {
                if (Math.floor(((transferInfo.totalReadedBytes / transferInfo.totalBytes) * 100)) > 100) {
                    percent = 100;
                } else {
                    percent = Math.floor(((transferInfo.totalReadedBytes / transferInfo.totalBytes) * 100));
                }
            }
        } else {//如果totalFileCount的数量大于2，则任务进度以nextCount为准
            if (Math.floor(((fileCountPercent) * 100)) >= 100) {
                percent = 100;
            } else {
                percent = Math.floor(((fileCountPercent) * 100));
            }

        }
        return percent;
    },
    calculateBackupPercent(transferInfo) {
        let percent;
        if (transferInfo.totalReadedBytes < 0) {
            if (transferInfo.nextCount) {//如果返回了nextCount，任务进度以fileCountPercent为准
                percent = transferInfo.nextCount / transferInfo.totalFileCount;
            } else {
                percent = 0;
            }
            return percent;
        }
        if (transferInfo.totalBytes > 0) {
            if (Math.floor(((transferInfo.totalReadedBytes / transferInfo.totalBytes) * 100)) > 100) {
                percent = 100;
            } else {
                percent = Math.floor(((transferInfo.totalReadedBytes / transferInfo.totalBytes) * 100));
            }
        } else {
            //如果没有大小，则使用文件数的判断
            if (Math.floor(((transferInfo.readyTranFileCount / transferInfo.totalFileCount) * 100)) > 100) {
                percent = 100;
            } else {
                percent = Math.floor(((transferInfo.readyTranFileCount / transferInfo.totalFileCount) * 100));
            }
        }

        return percent;

    },
    //获取临时任务的进度
    getCrossProgress(getProData, name, direction) {
        let t;
        let that = this;
        Utils.doTasksRequest('get_progress', getProData).then(response => {
            if (response.progress) {//如果后端成功返回进度
                let progress = response.progress.state2;//把state2返回为progress
                if (response.progress.entities) {//对后端返回的entities在运行的放在第一个
                    if (response.progress.entities.length) {
                        $.each(response.progress.entities, function (i, eItem) {
                            if (eItem.rate != -1) {
                                response.progress.entities.splice(i, 1);
                                response.progress.entities.unshift(eItem);
                            }
                        });
                    }
                }
                $.each(store.state.retryItems, function (index, item) {//遍历待处理任务列表
                    if (item.taskId == progress.taskId) {//找到taskId相等的那条待执行数据
                        if (store.state.detailedProgrssData.length) {//遍历临时任详情数据
                            $.each(store.state.detailedProgrssData, function (taskIndex, taskDataItem) {
                                if (taskDataItem.taskId == progress.taskId && item.status != 4) {//找到与taskId相等的那条进度数据
                                    if (!progress.desNode.length) {
                                        progress.desNode = taskDataItem.desNode;
                                    }
                                    if (!store.state.detailTaskOpen) {//如果此时没有页面展开则默认展开第一个页面
                                        taskDataItem.open = true;
                                        store.state.detailTaskOpen = true;
                                    }
                                    if (taskDataItem.open) {
                                        progress.open = taskDataItem.open;
                                    }
                                    store.state.detailedProgrssData.splice(taskIndex, 1);//把这条正在执行的临时任务数据放在第一个
                                    store.state.detailedProgrssData.unshift(progress);
                                    progress.itemProgressInfo = item;//item复制给itemProgressInfo
                                    direction.$forceUpdate();
                                    return false;
                                }
                            });
                        }
                        //设置任务的详情为进度
                        item.detail = JSON.parse(JSON.stringify(progress));
                        item.entities = response.progress.entities;//把progress.entities赋值给entities
                        if (progress.totalBytes != 0) {
                            let percent = that.calculationPercent(progress);
                            if (!item.percent) {
                                item.percent = 0;
                            }
                            if (percent >= item.percent) {
                                item.percent = percent;
                            }
                            if (item.percent > 100) {//如果进度大于100，设置为100，防止界面溢出
                                item.percent = 100;
                            }
                            if (direction.$refs.snapTaskDialog) {
                                direction.$refs.snapTaskDialog.$forceUpdate();
                            }
                        } else {//如果totalBytes为0则设进度为0
                            item.percent = 0;
                        }
                        if (!item.readyBytes) {
                            item.readyBytes = 0;
                        }
                        item.oldReadyBytes = item.readyBytes;//把上一个readyBytes设为oldReadyBytes
                        item.readyBytes = progress.readedBytes;//把现在已读的readedBytes设为现在的readyBytes
                        let interval = (item.readyBytes - item.oldReadyBytes) / 4;//计算每格4秒后的速度
                        if (interval) {
                            item.speed = Utils.formatByteSpeed(interval);
                        }
                        direction.$forceUpdate();//如果进度不等于100，并且没有报错，则继续获取后端进度
                        if (!item.detail.errorList.length && ((item.percent != 100 && item.detail.response != "success") || (item.detail.nextCount != item.detail.totalFileCount) || (!item.detail.response) || (item.detail.response == 1))) {
                            t = setTimeout(() => {
                                delete getProData.s;
                                that.getCrossProgress(getProData, name, direction);
                            }, 4000);
                        } else { //若进度等于100并没有报错，并且后端响应的是成功
                            if (item.detail && !item.detail.errorList.length && item.detail.response == "success") {
                                item.percent = 100;
                                direction.$forceUpdate();
                                if (direction.$refs.snapTaskDialog) {
                                    direction.$refs.snapTaskDialog.$forceUpdate();
                                }
                                clearTimeout(t);//删除定时
                                that.detailProgressSuccessEnd(item, index, direction);//任务执行成功
                                //若进度等于100并报错则任务任务为失败
                            } else if (item.detail && (item.detail.errorList.length || item.detail.response != "success")) {
                                if (item.detail.status == 2) {
                                    // 这种情况下任务还在执行
                                    t = setTimeout(() => {
                                        delete getProData.s;
                                        that.getCrossProgress(getProData, name, direction);
                                    }, 4000);
                                } else {
                                    // 以前的逻辑
                                    clearTimeout(t);
                                    if(direction.$route.name != 'taskList'){
                                        direction.$toast({
                                            text: 'Transferring:"' + name + '" failed.',
                                            type: 'fail',
                                            idValue:'rightBo',
                                        });
                                    }
                                    that.detailProgressFailedEnd(item, index, direction);//任务执行失败
                                }
                            }
                        }
                        return false;
                    }
                });
                direction.$forceUpdate();//强制刷新界面
            } else { //若任务未返回进度
                $.each(store.state.retryItems, function (index, item) {//遍历待处理的临时任务
                    if (item.taskId == getProData.wd) {//任务的taskI等于wd
                        clearTimeout(t);
                        //进度执行结束并未发生错误,则让任务显示成功
                        // || response.reason == "noTaskRunning"
                        if ((item.detail && !item.detail.errorList.length) || response.message == "Success") {
                            if (store.state.detailedProgrssData.length) {
                                $.each(store.state.detailedProgrssData, function (taskIndex, taskDataItem) {
                                    if (taskDataItem.taskId == item.taskId) {
                                        if (!taskDataItem.itemProgressInfo) {
                                            taskDataItem.itemProgressInfo = {};
                                        }
                                        taskDataItem.status = 4;
                                        taskDataItem.itemProgressInfo.percent = 100;
                                        taskDataItem.itemProgressInfo.status = 4;
                                        item.status = 4;
                                        that.detailProgressSuccessEnd(item, index, direction);
                                        direction.$forceUpdate();
                                        return false;
                                    }
                                });
                            }
                            //进度执行结束发生错误，则为失败
                        } else if (item.detail && (item.detail.errorList.length) || response.status != 200) {
                            clearTimeout(t);
                            if(direction.$route.name != 'taskList'){
                            direction.$toast({
                                text: 'Transferring:"' + name + '" failed.',
                                type: 'fail',
                                idValue:'rightBo',
                            });
                           }
                            that.detailProgressFailedEnd(item, index, direction);
                        }
                        return false;
                    }
                });
            }
        }, err => {//如果断网或者网络不稳定
            t = setTimeout(() => {
                delete getProData.s;
                that.getCrossProgress(getProData, name, direction);
            }, 4000);
        });
    },
    //临时任务失败结束后进行的操作
    detailProgressFailedEnd(item, index, direction) {
        let that = this;
        let taUnfinish = store.state.detailTabUnfinished;
        $.each(store.state.detailedProgrssData, function (index, taskItem) {//遍历任务详情列表
            if (taskItem.taskId == item.detail.taskId) {//找到详情相等的id,将任务状态设为完成失败
                delete taskItem.itemProgressInfo.percent;
                delete item.percent;
                taskItem.status = 4;
                taskItem.itemProgressInfo.status = 4;
                taUnfinish.push(taskItem);
                direction.$forceUpdate();
                that.refreshUserInfo(direction, function (res) { });//刷新用户流量
                if (store.state.retryItems[index].taskId == item.taskId) {//在待处理列表删除该失败数据
                    store.state.retryItems.splice(index, 1);
                }
                taskItem.errorList = item.detail.errorList;//给错误信息赋值
                taskItem.readyTranFileCount = item.detail.readyTranFileCount;
                taskItem.totalFileCount = item.detail.totalFileCount;
                that.deletePasteTask(item, function (res) {//调用删除该任务数据
                    //立刻将下一将要处理任务移到第一个
                    $.each(store.state.detailedProgrssData, function (taskIndex, taskDataItem) {
                        if (store.state.retryItems[0] && taskDataItem.taskId == store.state.retryItems[0].taskId) {//找到和待执行的第一个任务的id
                            store.state.detailedProgrssData.splice(taskIndex, 1);//把该待执行的任务显示在第一个位置
                            store.state.detailedProgrssData.unshift(taskDataItem);
                            return false;
                        }
                    });
                    that.runDetailProgressData(direction);//开始执行下一个任务
                });
                direction.$forceUpdate();
                return false;
            }
        });
    },
    //临时任务成功结束后进行的操作
    detailProgressSuccessEnd(item, index, direction) {
        let that = this;
        let allData = store.state.retryItems;
        let tabSuccess = store.state.detailTabSuccess;
        let taUnfinish = store.state.detailTabUnfinished;
        $.each(store.state.detailedProgrssData, function (index2, taskItem) {
            if (taskItem.taskId == item.taskId) {//找到详情相等的id,将任务状态设为完成成功
                taskItem.status = 4;
                if (taskItem.itemProgressInfo) {
                    taskItem.itemProgressInfo.status = 4;
                    taskItem.itemProgressInfo.percent = 100;
                } else {
                    taskItem.itemProgressInfo = {};
                    taskItem.itemProgressInfo.status = 4;
                    taskItem.itemProgressInfo.percent = 100;
                }
                var str = that.getTaskStr(taskItem);
                if (str == "success") {
                    tabSuccess.push(taskItem);
                } else {
                    taUnfinish.push(taskItem);
                }
                that.refreshUserInfo(direction, function (res) { });//刷新用户流量
                store.state.loadFlag = false;
                if (store.state.retryItems[0]) {
                    that.toItem = store.state.retryItems[0];
                }
                direction.$nextTick(function () {
                    //刷新目标目录并把数据保存在copy to 弹窗
                    if (store.state.retryItems[index] && store.state.retryItems[index].taskId == item.taskId) {
                        store.state.retryItems[index].percent = 100;
                        store.state.retryItems.splice(index, 1);
                    }
                    that.deletePasteTask(item, function (res) {
                        //立刻将下一将要处理任务移到第一个
                        $.each(store.state.detailedProgrssData, function (taskIndex, taskDataItem) {
                            if (store.state.retryItems[0] && taskDataItem.taskId == store.state.retryItems[0].taskId) {
                                store.state.detailedProgrssData.splice(taskIndex, 1);
                                store.state.detailedProgrssData.unshift(taskDataItem);
                                return false;
                            }
                        });
                        that.runDetailProgressData(direction);//开始执行下一个任务
                    });
                    that.toItemDataRefresh(direction, function (res) {//刷新目标目录
                        let direction = that.getDriction();
                        if (direction.$route.name == 'cloudExploer' || direction.$route.name == 'subAccountTeam') {
                            direction.JudgeReacquireData();
                        }
                        direction.$forceUpdate();
                    });
                });
                return false
            }
        });
    },
    // 获取任务标识
    getTaskStr(item){
        var status = item.status;
        if (status == 0) {
            return "ready";
        } else if (status == 1) {
            return "run";
        } else if (status == 2) {
            return "run";
        } else if (status == 3) {
            return "cancel";
        } else if (status == 4) {
            var cur = item.readyTranFileCount;
            var sum = item.readyFindFileCount;
            var result = cur / sum;
            if (result == 1) {
                return "success";
            } else if (result >= 0.8) {
                return "success8";
            } else {
                return "error";
            }
        } else {
            return "unknown";
        }
    },
    // 退出登录和跳转到登录页
    logoutAndJumpToSign() {
        this.logout_clear();
        var hostname = location.hostname;
        if (hostname == 'localhost') {
            location.href = 'http://localhost:8080/share/sign';
            return;
        } else if (hostname.indexOf('test') == 0) {
            location.href = 'https://' + hostname + '/sign';
            return;
        } else {
            location.href = 'https://www.multcloud.com/sign.html';
            return;
        }
    },
    //更新用户的流量信息
    refreshUserInfo(direction, callback) {
        let user = this.getUser();
        Utils.doUserHaveLoginRequest('get', {
            ud: user.id,
            salt: user.salt
        }).then(response => {
            // 盐值失效，跳转到登录
            if (response.status==401 && response.reason=='saltInvalid') {
                this.logoutAndJumpToSign();
                return;
            }
            user = response.user;
            if(user) {
                if (user.password && user.password.length > 10) {
                    store.commit('setPassWord', user.password);
                    delete user.password;
                }
                this.setUserToLocal(user);
                this.setUserCookies(user);
                if (direction.$parent && direction.$parent.$refs.rightContBan) {
                    direction.$parent.$refs.rightContBan.email = user.email;
                    direction.$parent.$refs.rightContBan.usedTraffic = user.usedBytes;
                    // if(user.vip&&user.payLevel>1){
                    // direction.$parent.$refs.rightContBan.usedTraffic = user.payUsedTraffic;
                    // }
                    direction.$parent.$refs.rightContBan.totalTraffic = user.totalBytes;
                    callback(user);
                    return;
                }
                if (direction.$parent && direction.$parent.languageArr && direction.$parent.languageArr.length) {
                    direction.$parent.email = user.email;
                    direction.$parent.usedTraffic = user.usedBytes;
                    // if(user.vip&&user.payLevel>1){
                    // direction.$parent.usedTraffic = user.payUsedTraffic;
                    // }
                    direction.$parent.totalTraffic = user.totalBytes;
                    callback(user);
                    return;
                }
                callback(user);
                return;
            }
        });
    },
    //cloudExploer listData 当跨云盘临时任务结束时，刷新目标目录数据
    toItemDataRefresh(direction, callback) {
        let toItem = this.toItem;
        let listData = new cloudExploerUtils.filelistData(toItem.desId, this.getUser().id, toItem.desToken);
        this.refreshTreeData(listData, toItem.desDriveType, toItem.aimPid, direction, function (res) {
            callback(res);
        });
        //如果是跨云盘的剪切，执行完后，刷新源
        if(toItem.remove){
            let fromlistData = new cloudExploerUtils.filelistData(toItem.sourcePid, this.getUser().id,toItem.sourceToken);
            this.refreshTreeData(fromlistData, toItem.sourceCloudType,toItem.sourcePid, direction, function(res) {
                if(direction.$route.name == 'cloudExploer'||direction.$route.name == 'emailExploer'||direction.$route.name == 'subAccountTeam'){
                    direction.selectItemArr=[];
                }
                callback(res);
            });
        }
    },
    //当上传任务成功时，刷新目录数据
    uploadTaskToItemDataRefresh(item, callback) {
        let that = this;
        let listData = new cloudExploerUtils.filelistData(item.uploadData.tid, this.getUser().id, item.uploadData.dd);
        this.refreshTreeData(listData, item.cloudType, item.uploadData.tid, null, function (res) {
            callback(res);
        });
    },
    //发送刷新目标目录数据请求
    toItemDataRefreshQuest(listData, item, callback) {
        let that = this;
        let clouds;
        Utils.doFilesRequest("list", listData).then(res => {
            if (res.status == 200) {
                if (res.items.length) {
                    for (let i = 0; i < res.items.length; i++) {
                        res.items[i].driveType = item.toItem.driveType;
                        res.items[i].pid = listData.id;
                        res.items[i].driveId = listData.dd;
                        if (store.getters.getlistData && store.getters.getlistData.cloud) {
                            res.items[i].cloud = store.getters.getlistData.cloud;
                        }
                        //将新增的数据封装到树形组件
                        if (store.getters.getUsersDrives.length && res.items.length <= 200) {
                            clouds = store.getters.getUsersDrives;
                            //封装新数据
                            var packageDatas = that.packageData(that.sortArr(res.items, true, 0), listData.dd, listData.id, store.state.transferFromOpen, item.toItem.driveType);
                            for (let j = 0; j < clouds.length; j++) {
                                if (clouds[j].driveInfo.id == listData.dd) {
                                    if (clouds[j].driveInfo.rootId == listData.id) {
                                        //找到改数据应该在的位置并赋值
                                        clouds[j].children = packageDatas;
                                    } else if (clouds[j].children) {
                                        that.getFileChildren(clouds[j].children, packageDatas, listData.id);
                                    }
                                }
                            }
                        }
                    }
                }
                store.commit("setCacheTableDatas", {
                    id: listData.id + listData.dd,
                    tableData: res.items
                });
            }
            callback(res);
        });
    },
    //计算所有项目的size
    countAllSize(items) {
        let allSize = 0;
        $.each(items, function (i, item) {
            allSize = allSize + item.size;
        });
        return allSize;
    },//onDrive传输后把文件大小也加入缓存
    commitOneDriveSize(res, desPid) {
        let allSize = this.countAllSize(res.items);
        let key = desPid + res.driveId;
        let tableDataArr = store.state.cacheTableDatas[key];
        let tableData = [];
        if (tableDataArr && tableDataArr.tableData) {
            tableData = tableDataArr.tableData;
            $.each(tableData, function (i, item) {
                if (item.id == res.id) {
                    item.size = allSize;
                    return false;
                }
            });
            store.commit("setCacheTableDatas", {
                id: key,
                tableData: tableData
            });
        }
    },//更新树形组件
    refreshTreeData(listData, driveType, desPid, direction, callback) {
        var clouds;
        let that = this;
        let docType = "";
        Utils.doFilesRequest("list", listData).then(res => {
            if (res.status == 200) {
                if (res.cloudType == 4 && desPid) {
                    this.commitOneDriveSize(res, desPid);//刷新OneDrive的size
                }
                //如果该文件夹包含类型，则需要进行记录
                if (res.type && direction && direction.docType) {
                    direction.docType = res.type;
                    docType = res.type;
                }
                if (res.items) {
                    for (let i = 0; i < res.items.length; i++) {
                        res.items[i].driveType = driveType;
                        res.items[i].pid = listData.id;
                        res.items[i].driveId = listData.dd;
                    }
                    //将新增的数据封装到树形组件
                    if (store.getters.getUsersDrives.length) {
                        clouds = store.getters.getUsersDrives;
                        //封装新数据
                        var packageDatas = that.packageData(that.sortArr(res.items, true, 0), listData.dd, listData.id,
                            store.state.transferFromOpen, driveType);
                        for (let j = 0; j < clouds.length; j++) {
                            if (clouds[j].driveInfo.id == listData.dd) {
                                if (clouds[j].driveInfo.rootId == listData.id) {
                                    //找到改数据应该在的位置并赋值
                                    clouds[j].children = packageDatas;
                                } else if (clouds[j].children) {
                                    that.getFileChildren(clouds[j].children, packageDatas, listData.id);
                                }
                            }
                        }
                    }
                }
                if (!this.pathExcludeBackupRoot(this.pathJson)) {
                    store.commit("setCacheTableDatas", {
                        id: listData.id + listData.dd,
                        docType: docType,
                        tableData: res.items
                    });
                }

            }
            callback(res);
        });
    },
    refreshTreeDataFromEmail(listData, driveType, desPid, direction, callback) {
        var clouds;
        let that = this;
        let docType = "";
        Utils.doCloudEmailRequest("list", listData).then(res => {
            if (res.status == 200) {
                //如果该文件夹包含类型，则需要进行记录
                if (res.type && direction && direction.docType) {
                    direction.docType = res.type;
                    docType = res.type;
                }
                let tableItems;
                let nextPage;
                if (res.items) {
                    for (let i = 0; i < res.items.length; i++) {
                        res.items[i].driveType = direction.$route.query.cloudType;
                        res.items[i].pid = listData.id;
                        res.items[i].driveId = listData.dd;
                        res.items[i].cloudType = res.cloudType;
                        if(res.items[i].docType=='category'){
                            //系统文件夹需要多语言
                            if(res.items[i].initial){
                              //保存原始名称
                              res.items[i].oldName = res.items[i].name;
                              if(res.items[i].name != "All Mail"){
                                res.items[i].name = direction.$t('language.emailExploer.folderName.'+res.items[i].name);
                              }else{
                                res.items[i].oldName = "AllMail";
                                res.items[i].name = direction.$t('language.emailExploer.folderName.AllMail');
                              }
                            }
                          }else{
                            if(!res.items[i].subject){
                                if(!res.items[i].name){
                                    //没有name也没有subject，默认显示无主题
                                    res.items[i].name = "No Subject";
                                }
                              //没有subject，默认显示无主题
                              res.items[i].subject = direction.$t('language.emailExploer.noSubject');
                            }
                            if(!res.items[i].name){
                              //没有name，默认subject为name
                              res.items[i].name = res.items[i].subject;
                            }
                          }
                          // if(res.items[i].docType=="thread"){
                          //   //没有queryParameter，默认threadId为queryParameter
                          //   res.items[i].id = res.items[i].id;
                          // }
                          if (direction.$store.getters.getlistData && direction.$store.getters.getlistData.cloud) {
                            res.items[i].cloud = Object.assign({}, direction.$store.getters.getlistData.cloud);
                          }
                          let item = res.items[i];
                          direction.packagePnode(item, direction.pathJson.length - 1); //前端手动给节点赋值
                    }
                    //如果此时用户未切换界面，把数据存入缓存
                    if (direction.$route.query.tokenId == listData.dd && listData.id == direction.$route.query.folderId) {
                        //是否有下一页
                        if(res.nextPage){
                            nextPage = res.nextPage;
                        }else{
                            //最后一页
                            nextPage = null;
                        }
                        
                        tableItems = Object.assign([], res.items);
                        //如果是会话页面
                        if(direction.$route.query.docType=="thread"&&tableItems.length>0){
                            //第一封邮件默认展开
                            tableItems[tableItems.length-1].isLast = true;
                        }
                        if(direction.$route.query.docType=='category'){
                            tableItems = that.sortArr(tableItems, this.upShow, 4);
                        }
                        if(direction.$route.query.cloudType=='outlook'){
                            tableItems = that.sortArrEmail(tableItems, true, 0);
                        }
                        direction.tableData = tableItems;
                    }
                    //将新增的数据封装到树形组件
                    if (store.getters.getUsersDrives.length) {
                        clouds = store.getters.getUsersDrives;
                        //封装新数据
                        var packageDatas = that.packageData(tableItems, listData.dd, listData.id,
                            store.state.transferFromOpen, driveType);
                        for (let j = 0; j < clouds.length; j++) {
                            if (clouds[j].driveInfo.id == listData.dd) {
                                if (clouds[j].driveInfo.rootId == listData.id) {
                                    //找到改数据应该在的位置并赋值
                                    clouds[j].children = packageDatas;
                                } else if (clouds[j].children) {
                                    that.getFileChildren(clouds[j].children, packageDatas, listData.id);
                                }
                            }
                        }
                    }
                }
                if (!this.pathExcludeBackupRoot(this.pathJson)) {
                    store.commit("setCacheTableDatas", {
                        id: listData.id + listData.dd,
                        docType: docType,
                        tableData: tableItems,
                        nextPage: nextPage
                    });
                }

            }
            callback(res);
        });
    },
    deletePasteTask(item, callback) {//删除一个运行结束的临时任务
        let reTryTime = 0;
        this.deletePasteTaskRequest(item, reTryTime, function (res) {
            callback(res);
        });
    },
    deletePasteTaskRequest(item, reTryTime, callback) {
        if (item.taskId) {
            let t = setTimeout(() => {
                let pasteTask = {
                    ud: this.getUser().id,
                    type: 4,
                    wd: item.taskId
                }
                Utils.doTasksRequest('remove_completed_task', pasteTask).then(response => {//调用删除临时任务接口
                    if (response.status == 200) {
                        clearTimeout(t);
                        callback(response);
                    } else if (response.reason != 'noTaskRunning') {//如果此时该任务还在运行，则不能删除，进行再次递归删除，直到执行成功删除完毕
                        reTryTime = reTryTime + 1;
                        if (reTryTime < 4) {
                            this.deletePasteTaskRequest(item, reTryTime, callback);
                        } else {
                            clearTimeout(t);
                            callback('end');
                        }
                    } else {
                        clearTimeout(t);
                        callback('end');
                    }
                });
            }, 1500);
        } else {
            callback('end');
        }
    },
    getFileChildren(children, packageDatas, id) {//获取打开过的子目录
        for (let k = 0; k < children.length; k++) {
            if (children[k].id == id) {
                children[k].children = packageDatas;
                return false;
            } else if (children[k].children) {
                this.getFileChildren(children[k].children, packageDatas, id);
            }
        }
    },
    closeTree(model) {//关闭树形组件
        let that = this;
        if (!model) {
            return;
        }
        $.each(model, function (index, item) {
            item.open = false;
            if (item.children && item.children.length) {
                that.closeTree(item.children);
            }
        });
    },
    //跳转到云盘管理界面显示目录
    toSourceCatalog(itemDetail, direction, callback) {
        let sourceNode = itemDetail.sourceNode;
        let folderId;
        let fileName;
        let leng = sourceNode.length;
        //若源为云盘根目录,点击后直接打开云盘根目录
        if (leng <= 1) {
            folderId = sourceNode[0].fileId;
            if (sourceNode[0].fileName) {
                fileName = sourceNode[0].fileName;
            } else {
                fileName = sourceNode[0].filename;
            }
        } else {
            //若源为云盘子文件夹/文件，点击后直接在上一级目录选中该文件夹
            folderId = sourceNode[1].fileId;
            if (sourceNode[1].fileName) {
                fileName = sourceNode[1].fileName;
            } else {
                fileName = sourceNode[1].filename;
            }
        }
        //如果有team信息且是team的分享，则跳转team页面
        let teamCloud = direction.$store.getters.getTeamCloud;
        let permissionId = sourceNode[sourceNode.length - 1].permissionId;
        if (teamCloud && permissionId && itemDetail.sourceCloudType == "team") {
            direction.$router.push({
                name: "subAccountTeam",
                query: {
                    cloudType: itemDetail.sourceCloudType,
                    folderId: permissionId + itemDetail.sourcePid,
                    folderName: fileName,
                    tokenId: teamCloud.id,
                    cloudId: teamCloud.id,
                }
            });
        } else if (itemDetail.sourceCloudType == "Shares") {
            let link = commonstate.sharePageUrl + itemDetail.sourceNode[itemDetail.sourceNode.length - 1].shareId;
            window.open(link);
        }else if(commonstate.emailClouds.includes(itemDetail.sourceCloudType)){
            //跳转到相应的路由
            direction.$router.push({
                name: "emailExploer",
                query: {
                    cloudType: itemDetail.sourceCloudType,
                    folderId: folderId,
                    folderName: fileName,
                    tokenId: itemDetail.sourceToken,
                    docType: itemDetail.docType,
                    queryParameter: itemDetail.queryParameter
                }
            });
        }else{
            //跳转到相应的路由
            direction.$router.push({
                name: "cloudExploer",
                query: {
                    cloudType: itemDetail.sourceCloudType,
                    folderId: folderId,
                    folderName: fileName,
                    tokenId: itemDetail.sourceToken
                }
            });
        }
        //callback必须返回文件的id，临时任务跳转会用到
        callback({ id: folderId, status: 200 });
    },//跳转到云盘的目标目录
    toAimSourceCatalog(aimData, direction, callback) {
        let aimNode = aimData.desNode;
        direction.isflage = false;
        let folderId = aimNode[0].fileId;
        let fileName;
        fileName = aimNode[0].fileName;
        if (!fileName) {
            fileName = aimNode[0].filename;
        }
        $.each(aimData.desNode, function (i, item) {
            if (!item.tokenId) {
                item.tokenId = aimData.desToken;
            }
        });
        //如果有team信息且是team的分享，则跳转team页面
        let teamCloud = direction.$store.getters.getTeamCloud;
        let permissionId = aimNode[aimNode.length - 1].permissionId;
        if (teamCloud && permissionId) {
            direction.$router.push({
                name: "subAccountTeam",
                query: {
                    cloudType: aimData.desCloudType,
                    folderId: permissionId + aimData.desId,
                    folderName: fileName,
                    tokenId: teamCloud.id,
                    cloudId: teamCloud.id,
                }
            });
        } else {
            direction.$router.push({
                name: "cloudExploer",
                query: {
                    cloudType: aimData.desCloudType,
                    folderId: folderId,
                    folderName: fileName,
                    tokenId: aimData.desToken
                }
            });
        }
        callback({ status: 200 });

    },
    //封装路径信息
    encapsulationPath(sourceAimData, pathData, direction) {
        let that = this;
        let pathJson = [];
        if (!pathData) {
            for (let i = sourceAimData.length - 1; i >= 0; i--) {
                let name = sourceAimData[i].fileName;
                if (!name) {
                    name = sourceAimData[i].filename;
                }
                pathJson.push({
                    id: sourceAimData[i].fileId,
                    name: name,
                    driveId: sourceAimData[i].tokenId
                });
                let JsonList = Object.assign([], pathJson);
                store.commit("setPathJson", {
                    folderId: sourceAimData[i].fileId + sourceAimData[i].tokenId,
                    json: JsonList
                });
            }
        }
    },
    //选中左侧的菜单栏
    selectOption(sourceNode, direction) {
        let dom;
        let rootDir;
        let that = this;
        $.each(direction.$parent.$children, function (i, item) {
            if (item.menuOptions) {
                dom = direction.$parent.$children[i];
                return;
            }
        });
        let clouds = Object.assign([], dom.clouds);
        rootDir = sourceNode[sourceNode.length - 1];
        $.each(clouds, function (i, item) {
            if ((rootDir.fileName == item.name && rootDir.tokenId == item.id) || (rootDir.filename == item.name && rootDir.fileId == item.rootId)) {
                dom.driveOptionSelect(item.id);
                direction.$store.commit('setCloudExploerPasteItems', item);
            }
        });
    },
    //判断是否有从其他界面跳转过来的选中数据，选中数据让滚动条显示在合适的位置
    ifHasDataSelect(direction) {
        var scrollDiv;
        var el;
        var table;
        var top;
        var offTop;
        var catalogFileId;
        direction.selectItemArr = [];
        //选中其他地方已跳转过来的文件id
        if (store.state.catalogFileId) {
            catalogFileId = store.state.catalogFileId;
            $.each(direction.tableData, function (i, item) {
                if (item.id == catalogFileId) {//找到该选中的文件
                    if (direction.listShow) {//如果是list显示
                        scrollDiv = direction.$refs['elscrollbar'].$refs['wrap'];//获取滚动条
                        table = document.getElementById('dropTableBox');//获取整个框
                    } else {
                        scrollDiv = direction.$refs['elscrollbarList'].$refs['wrap']; //获取滚动条
                        table = document.getElementById('gridList');//获取整个框
                    }
                    if (store.state.comeBackFileFlag) {//如果是返回上一级目录，需要是长度在底下才选中
                        if (direction.listShow) {
                            if (i * 40 + 80 > table.offsetHeight) {
                                direction.selectItemArr.push(item);
                                direction.$nextTick(() => {
                                    el = document.getElementsByClassName('tr-back-ground');//滚动到哪
                                    offTop = el[0].offsetTop;
                                    top = el[0].offsetTop - table.offsetHeight + 80;
                                    scrollDiv.scrollTop = top;//给一个滚动的值
                                });
                            }
                        } else {
                            let width = table.offsetWidth;//整个页面的宽度
                            let num = parseInt(width / 128);//每行的个数
                            let line = (i + 1) / num;//算出在第几行
                            if (line * 145 + 180 > table.offsetHeight) {//如果出现了滚动条
                                direction.selectItemArr.push(item);
                                direction.$nextTick(() => {
                                    el = document.getElementsByClassName('check-small');//滚动到哪
                                    offTop = el[1].parentNode.parentNode.parentNode.offsetTop;
                                    top = offTop - table.offsetHeight + 180;
                                    scrollDiv.scrollTop = top; //给一个滚动的值
                                });
                            }
                        }
                    } else {
                        direction.selectItemArr.push(item);//选中该文件
                    }
                    store.state.catalogFileId = '';
                    store.state.comeBackFileFlag = false;
                    return false;
                }
            });
        }
    },
    //前端判断是否有重复文件/文件夹,不区分大小写，有则重命名
    includesFileName(resAllDataName, n, direction) {
        let reName;
        if (resAllDataName.length) {
            for (var i = 0; i < resAllDataName.length; i++) {
                if (resAllDataName[i].toLowerCase() === n.toLowerCase()) {
                    let result = '';
                    let regex = /\((.+?)\)/g;
                    let options = n.match(regex);
                    if (options) { //看是否包含括号
                        let option = options[0];
                        if (option) {
                            let suffix = this.getSuffix(n);
                            let preFix = this.getPrefix(n);
                            let preFixIndex = preFix.lastIndexOf("(");
                            let preFixValue = preFix.substring(0, preFixIndex).trim();
                            result = parseInt(option.substring(1, option.length - 1)) + 1;
                            if (suffix) {
                                reName = preFixValue + '(' + (result) + ').' + suffix;
                            } else {
                                reName = preFixValue + '(' + (result) + ')';
                            }
                        }
                    } else {
                        let suffix = this.getSuffix(n);
                        let preFix = this.getPrefix(n).trim();
                        if (suffix) {
                            reName = preFix + '(' + 1 + ').' + suffix;
                        } else { //如果没有后缀
                            reName = preFix + '(' + 1 + ')';
                        }
                    }
                    this.includesFileName(resAllDataName, reName, direction);
                    return false;
                }
                if (i == resAllDataName.length - 1) {
                    direction.reName = n;
                    return false;
                }
            }
        } else {
            direction.reName = n;
        }
    },
    //判断云盘名称是否重复，如果重复则自动重命名
    includesDriveName(driveNameArr, newName, direction) {
        if (driveNameArr.length) {
            //定义正则【g表示全局匹配，$标识以其结尾，小括号表示小分组也就是exec方法要捕获的部分】
            var reg = /(\d+)$/g;
            for (let i = 0; i < driveNameArr.length; i++) {
                if (driveNameArr[i].trim().toLowerCase() === newName.trim().toLowerCase()) {
                    //匹配正则获取小分组捕获结果
                    var result = reg.exec(newName);
                    if (result) {//如果没有匹配到，则result为null
                        var matchNum = result[1];//结果数组中角标为1的值就是我们捕获的正则小分组中的串
                        matchNum = parseInt(matchNum) + 1;
                        let index = parseInt(result.index);
                        let nameString = newName.substring(0, index);
                        newName = nameString + matchNum;
                        this.includesDriveName(driveNameArr, newName, direction);
                        return false;
                    } else {
                        newName = newName + 1;
                        this.includesDriveName(driveNameArr, newName, direction);
                        return false;
                    }
                }
                if (i == driveNameArr.length - 1) {
                    direction.reName = newName;
                    return false;
                }
            }
        } else {
            direction.reName = newName;
        }
    },
    //用户粘贴时判断是否重命名
    pasteIncludesFileName(resAllDataName, n) {
        let reName;
        if (resAllDataName.includes(n)) {
            let result = '';
            let regex = /\((.+?)\)/g;
            let options = n.match(regex);
            if (options) { //看是否包含括号，如果包含括号
                let option = options[options.length - 1];
                if (option) {
                    let suffix = this.getSuffix(n);//获取名称的后缀
                    let preFix = this.getPrefix(n);//获取该名称的前缀
                    let preFixIndex = preFix.lastIndexOf("(");//获取最后一个前括号的下标
                    let preFixValue = preFix.substring(0, preFixIndex).trim();//获取括号前面的文字
                    result = parseInt(preFix.substring(preFixIndex + 1, preFixIndex + 2)) + 1;//获取括号里面的数值
                    if (suffix) {
                        reName = preFixValue + '(' + result + ').' + suffix;
                    } else {
                        reName = preFixValue + '(' + result + ')';
                    }
                }
            } else {
                let suffix = this.getSuffix(n);
                let preFix = this.getPrefix(n).trim();
                if (suffix) {
                    reName = preFix + '(' + 1 + ').' + suffix;
                } else { //如果没有后缀
                    reName = preFix + '(' + 1 + ')';
                }
            }
            this.pasteIncludesFileName(resAllDataName, reName);
        } else {
            this.reName = n;
            return false;
        }
    },//进入界面初始化看是否显示临时任务
    mountedDetailData(direction) {
        let that = this;//如果存在任务详情数据、待执行临时任务数据、待上传数据
        if (direction.$store.state.retryItems.length || direction.$store.state.detailedProgrssData.length || direction.$store.state.uploadArr.length) {
            let snapData = Object.assign([], direction.$store.state.retryItems);
            let uploadArr = Object.assign([], direction.$store.state.uploadArr);
            direction.$refs.snapTaskDialog.items = snapData.concat(uploadArr);
            direction.$refs.detailedProgrss.$refs.tab1.taskDatas = store.state.detailedProgrssData;
            this.allotDetailedProgrssData();//将数据分装到不同的界面
            direction.snapTaskIconShow = true;//显示临时任务界面
            if (direction.$store.state.snapTaskShow) {
                direction.$store.state.snapTaskShow = true;
            }
            direction.$store.state.loadFlag = true;
        }
        if (!direction.$store.state.retryItems.length) { //只要临时任务窗口还没有数据就调用接口查看后端是否有任务数据
            let t = setTimeout(() => { //加定时器，防止界面刷新的时候加载
                let progrssData = {
                    ud: that.getUser().id,
                    type: 4
                }
                Utils.doTasksRequest("list_running_tasks", progrssData).then(res => {
                    if (res.states && res.states.length) {
                        //刷新界面若任务加载未完毕，则显示临时任务窗口，反之则关闭
                        direction.snapTaskIconShow = true;
                        direction.$store.state.snapTaskShow = true;
                        direction.$store.state.cancelAllFlag = true;
                        this.judgeNewDataFlag(direction);
                        let tabSuccess = store.state.detailTabSuccess;
                        let taUnfinish = store.state.detailTabUnfinished;
                        let allResTasks = res.states;
                        $.each(allResTasks, function (i, item) {
                            if (item.status < 3) {//如果有还未执行的数据，则将数据放在待执行界面
                                direction.$store.state.retryItems.push({
                                    name: item.sourceFilename,
                                    status: 'ready',
                                    taskId: item.taskId,
                                    desId: item.desId,
                                    desToken: item.desToken,
                                    aimPid: item.desNode[item.desNode.length - 1].fileId,
                                    sourcePid: item.sourcePid,
                                    remove: item.remove,
                                    sourceCloudType: item.sourceCloudType
                                });
                            } else {
                                that.deletePasteTask(item, function (res) { });//如果数据已经完成，则删除已完成的数据
                            }
                            if (item.status == 4) {//如果任务状态我完成，放入成功界面
                                item.percent = 100;
                                var str = that.getTaskStr(item);
                                if (str == "success") {
                                    tabSuccess.push(item);
                                } else {
                                    taUnfinish.push(item);
                                }
                            } else if (item.totalBytes != 0) {
                                item.percent = ((item.readedBytes / item.totalBytes) * 100).toFixed(2);
                            } else {
                                item.percent = 0;
                            }
                            item.itemProgressInfo = Object.assign({}, item);
                            direction.$store.state.detailedProgrssData.push(item);
                        });
                        that.letFlagTrue();//将标志置为真
                    }
                });
                clearTimeout(t);
            }, 1000);
        }
    },
    createFormData(uploadFileData) {
        let formData = new FormData();
        formData.append("file", uploadFileData);
        return formData;
    },
    getDriction() {
        //当界面的指向direction
        let direction;
        if (window.vm && window.vm.$children) {
            //获取当前界面的vue值
            direction = window.vm.$children[0].$refs.routerView.$refs.routView;
        }
        return direction;
    },
    //调用上传接口
    uploadFileChange() {
        let that = this;
        let direction = that.getDriction();
        //如果上传列表长度大于0
        if (direction.$store.state.uploadArr.length > 0) {
            if (this.uploadFlag) {//如果执行上传标志为真
                let allUploadData = direction.$store.state.uploadArr;
                let data = allUploadData[0].uploadData;
                allUploadData[0].uploadStart = true;//该数据长传标志设为真
                that.uploadFlag = false;
                let data1 = Object.assign({}, data);
                delete data1.upId;
                Utils.doFilesRequest("upload.createSession", data1, { timeout: 1800000 }).then(result => {//调用上传接口,并将超时时间设为半小时
                    if (result.status == 200) {
                        that.uploadFile(result.upload_id, data, allUploadData[0].uploadFileData, function (result1) {//调用上传接口
                            if (result1.status == 200 || result1.status == 202) {
                                that.uploadFlag = true;
                                if (direction.$store.state.uploadArr[0].uploadData.upId == data.upId) {//上传成功后删除该条数据
                                    if (direction.$route.query.tokenId == data.dd) {
                                        that.uploadTaskToItemDataRefresh(allUploadData[0], function (res) {
                                            if (direction.$route.name == 'cloudExploer' || direction.$route.name == 'subAccountTeam') {
                                                if (direction.JudgeReacquireData && direction.isflage) {
                                                    direction.JudgeReacquireData();
                                                }
                                            }
                                            direction.$forceUpdate();
                                        });
                                    }
                                    direction.$store.state.uploadArr.splice(0, 1);
                                }
                                if (direction.$store.state.retryItems == 0 && direction.$store.state.uploadArr.length == 0) {//任务列表执行完毕后刷新界面
                                    direction.$refs.snapTaskDialog.transferFlag = true;
                                } else {
                                    //再次上传
                                    that.uploadFileChange();
                                }
                            } else {
                                //再次上传
                                that.uploadFlag = true;
                                that.uploadFileChange();
                            }
                        });
                    } else {
                        if (direction.$store.state.uploadArr[0].name == data.n) {
                            direction.$store.state.uploadArr.splice(0, 1);
                        }
                        if (result.status == 202) {
                            direction.$toast({
                                text: direction.$t('language.cloudExploer.duplicatePhoto'),
                                type: 'fail',
                                idValue: "rightBo"
                            });
                        }else if (result.reason == 'iCloudDriveNotEnoughSpace') {
                            direction.$toast({
                                text: direction.$t('language.exception.iCloudDriveNotEnoughSpace'),
                                type: 'fail',
                                idValue: "leftBan"
                            });
                        } else if (result.reason == 'uploudFileSizeIsZero') {
                            direction.$toast({
                              text: direction.$t('language.exception.uploudFileSizeIsZero'),
                              type: 'fail',
                              idValue: "leftBan"
                            });
                          } else if (result.reason == 'notUploudSpecialFile') {
                            direction.$toast({
                              text: direction.$t('language.exception.notUploudSpecialFile'),
                              type: 'fail',
                              idValue: "leftBan"
                            });
                          } else {
                            direction.$toast({
                                text: data.n + ' ' + direction.$t('language.cloudExploer.notUpload'),
                                type: 'fail',
                                idValue: "rightBo"
                            });
                        }
                        that.uploadFlag = true;
                        that.uploadFileChange();
                    }
                }, err => {
                    that.uploadFlag = true;
                    direction.$toast({
                        text: err,
                        type: 'fail',
                        idValue: "rightBo"
                    });

                });
            }
        } else {//任务执行完毕，transferFlag置为真
            if (direction.$store.state.retryItems <= 0 && direction.$store.state.uploadArr.length <= 0) {
                direction.$refs.snapTaskDialog.transferFlag = true;
            }
        }
    },
    //上传文件
    uploadFile(id, data, uploadFileData, callback) {
        let direction;
        if (window.vm && window.vm.$children) {
            //获取当前界面的vue值
            direction = window.vm.$children[0].$refs.routerView.$refs.routView;
        }
        let that = this;
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function (e) {
                //如果lengthComputable为false，就获取不到e.total和e.loaded
                if (e.lengthComputable) {
                    var rate = e.loaded / e.total; //已上传的比例
                    if (rate > 0) {
                        //获取上传进度，不能直接显示为100%，不然用户会误以为已经上传完毕，关掉浏览器的话就可能导致上传失败
                        $.each(direction.$store.state.uploadArr, function (index, item) {
                            if (item.uploadData.upId == data.upId) {
                                item.percent = parseInt(((rate - 0.001) * 100).toFixed(0));
                                if (item.percent == -0) {
                                    item.percent = 0;
                                }
                            }
                        });
                    }
                }
            }
        }
        //调用上传接口
        let formData = that.createFormData(uploadFileData);
        var msg;
        Utils.doUploadProgressRequest("/files/" + id + "/upload", formData, config, function (result) {
            if (result.status == 200) {
                $.each(direction.$store.state.uploadArr, function (index, item) {
                    //成功响应,进度设为100%
                    if (item.uploadData.upId == data.upId) {
                        item.percent = 100;
                        callback(result);
                    }
                });
            } else if (result.status == 202) {
                $.each(direction.$store.state.uploadArr, function (index, item) {
                    //成功响应,进度设为100%
                    if (item.uploadData.upId == data.upId) {
                        item.percent = 100;
                        direction.$toast({
                            text: direction.$t('language.cloudExploer.duplicatePhoto'),
                            type: 'fail',
                            idValue: "leftBan"
                        });
                        callback(result);
                    }
                });
            } else if (result.message && result.message.match("取消上传")) {
                callback(result);
            } else {
                //如果上传失败，则给失败任务标记
                $.each(direction.$store.state.uploadArr, function (index, item) {
                    //响应失败，给失败标记
                    if (item.uploadData.upId == data.upId) {
                        if (result.reason == 'uploadPermissionLimited') {
                            direction.$toast({
                                text: direction.$t('language.exception.uploadPermissionLimited'),
                                type: 'fail',
                                idValue: "leftBan"
                            });
                        } else if (result.reason == 'iCloudDriveNotEnoughSpace') {
                            direction.$toast({
                                text: direction.$t('language.exception.iCloudDriveNotEnoughSpace'),
                                type: 'fail',
                                idValue: "leftBan"
                            });
                        } else if (result.reason == 'noUploadPermission') {
                            direction.$toast({
                                text: direction.$t('language.exception.noUploadPermission'),
                                type: 'fail',
                                idValue: "leftBan"
                            });
                        } else if (result.reason == 'uploudFileSizeIsZero') {
                            direction.$toast({
                              text: direction.$t('language.exception.uploudFileSizeIsZero'),
                              type: 'fail',
                              idValue: "leftBan"
                            });
                          } else if (result.reason == 'notUploudSpecialFile') {
                            direction.$toast({
                              text: direction.$t('language.exception.notUploudSpecialFile'),
                              type: 'fail',
                              idValue: "leftBan"
                            });
                          } else if (result.reason == 'notRenameApp') {
                            direction.$toast({
                              text: direction.$t('language.exception.notRenameApp'),
                              type: 'fail',
                              idValue: "leftBan"
                            });
                          } else {
                            item.status = 'failed';
                            direction.$toast({
                                text: item.name + ' ' + direction.$t('language.cloudExploer.notUpload'),
                                type: 'fail',
                                idValue: "leftBan"
                            });
                        }
                        let t = setTimeout(() => {
                            direction.$nextTick(function () {
                                direction.$store.state.uploadArr.splice(0, 1);
                                callback(result);
                            });
                            clearTimeout(t);
                        }, 1000);
                        return false;
                    }
                });
            }
        }, err => {
            direction.$toast({
                text: err,
                type: 'fail',
                idValue: "leftBan"
            });
        });
    },
    //让标志设置为true 并触发监听事件
    letFlagTrue(direction) {
        store.state.haveNewSnapData = false;
        let t = setTimeout(() => {
            store.state.haveNewSnapData = true;
            clearTimeout(t);
        }, 10);
        store.state.loadFlag = true;
    },
    judgeNewDataFlag(direction) {
        if (!direction.$store.state.retryItems.length) {
            direction.$store.state.newDataFlag = true;
        } else if (!direction.$store.state.loadFlag) { //如果后端接口已经返回了数据,并且调用了获取进度接口，才不让其他任务读取进度
            direction.$store.state.newDataFlag = false;
        }
    },
    judgePasteNewDataFlag(direction) { //判断同云盘粘贴
        if (!direction.$store.state.retryItems.length) {
            direction.$store.state.newDataFlag = true;
        } else { //如果临时任务列表有数据，并且已经返回了数据
            direction.$store.state.newDataFlag = false;
        }
    },
    changeTaskNameLength(allTasklistData, direction) {
        direction.allLength = allTasklistData.length + 1;
        direction.inputValue = this.judgeRepeatTaskName(allTasklistData, direction);
        if (direction.$refs.editInput) {
            direction.$refs.editInput.value = direction.inputValue;
        }
    },
    //初始化界面的任务名称
    initPageName(direction, idValue) {
        let that = this;
        direction.$store.state.arr = [];
        let allTasklistData = direction.$store.state.taskListArr;
        if (!allTasklistData.length) {
            taskListUtils.inintTaskList(function (res) {
                //    if (res.status != 200 && res != 'fail') {//不等于fail表示进入了inintTaskList函数，但请求返回失败
                //     direction.$toast({
                //         text:direction.$t('language.exception.' + res.reason),
                //         type: 'fail',
                //         idValue:idValue
                //     });
                //     return false;
                // }
                direction.$store.state.taskListFlag = true;
                allTasklistData = direction.$store.state.taskListArr;
                that.changeTaskNameLength(allTasklistData, direction);//改变任务名长度
            });
        } else {
            that.changeTaskNameLength(allTasklistData, direction);
        }
    },
    //禁用某个界面的拖拽功能
    dragDisAble(idValue, driction) {
        //禁用拖拽上传功能
        var dropbox = document.getElementById(idValue);
        if (dropbox) {
            dropbox.addEventListener('dragenter', driction.onDrag, false);
            dropbox.addEventListener('dragover', driction.onDrag, false);
            dropbox.addEventListener('drop', driction.onDrag, false);
        }
    },
    //提交任务名称
    submiTaskName(driction) {
        driction.inputValue = driction.$refs.editInput.value;
        driction.inputValue = driction.inputValue.replace(/(^\"*)|(\"*$)/g, "").replace(/\s+/, ' ');
        if (!driction.inputValue || driction.inputValue == " ") {
            driction.$refs.editInput.cancelTaskName();
        } else {
            driction.$refs.editInput.inputShow = false;
        }
    },
    getLocaleFrom(str) {
        switch (str) {
            case 'de-DE':
                return "deutsch";
            case 'fr-FR':
                return "france";
            case 'pt-PT':
                return "portuguese";
            case 'ja-JP':
                return "japanese";
            case 'zh-TW':
                return "traditionalChinese";
            case 'zh-CN':
                return "chinese";
            case 'es-ES':
                return "spanish";
            case 'it-IT':
                return "italian";
            case 'nl-NL':
                return "nederlands";
            default:
                return "english";
        }
    },
    //获取用户
    getUser() {
        //如果缓存中没有用户信息则从路径中拿
        var localUser = this.getUserToLocal();
        var cookieUser = this.getUserCookies();
        var newUser;
        if(localUser&&cookieUser){
            newUser = localUser.lastTime>cookieUser.lastTime?localUser:cookieUser;
        }else {
            newUser = localUser?localUser:cookieUser;
        }
        return newUser;
    },
    //获取用户
    getNewUser(callback) {
        //如果缓存中没有用户信息则从路径中拿
        var getData = this.getQueryJSON();
        if (getData&&getData.source!="ext") {
            var str = getData.callBack;
            if (!str) {
                if (localStorage.getItem("user")) {
                    var newUser = this.getUserToLocal();
                    callback(newUser);
                    return;
                }else if($cookies.get('user')){
                    callback(this.getUserCookies());
                    return;
                }
                callback(null);
                return;
            }
            getData = JSON.parse(window.atob(str));
            if (!localStorage.getItem("locale") && getData.language) {
                localStorage.setItem('locale', this.getLocaleFrom(getData.language));
            }
            // if(getData.xcd){
            //     $cookies.set('x-cd',getData.xcd);
            // }
            $cookies.remove('x-cd', commonstate.nowNewUrl);
            var that = this;
            Utils.doUserHaveLoginRequest('get', {
                ud: getData.ud,
                salt: getData.salt
            }).then(response => {
                if (response.user) {
                    var user = response.user;
                    if (getData.psd) {
                        localStorage.setItem(user.id + 'interimPsd', getData.psd);
                    }
                    let tempUser = JSON.parse(JSON.stringify(user));
                    delete tempUser.email;
                    sessionStorage.setItem("user", JSON.stringify(tempUser));
                    if (user.password && user.password.length > 10) {
                        store.commit('setPassWord', user.password);
                        //delete user.password;
                    }
                    this.setUserToLocal(user);
                    this.setUserCookies(user);
                    //保存设备信任码
                    if (getData.tdcode) {
                        var td = this.getTrustedDeviceByEmail(user.email);
                        if (td != getData.tdcode) {
                            var tdJson = localStorage.getItem("trustedDevice");
                            if (tdJson) {
                                tdJson = JSON.parse(tdJson);
                            } else {
                                tdJson = {};
                            }
                            //更新设备信任码
                            tdJson[Utils.strAESKeyEncrypt(user.email, commonstate.ENCRYPT_KEY)] = getData.tdcode;
                            localStorage.setItem("trustedDevice", JSON.stringify(tdJson));
                        }
                    }
                    if (getData.open) {
                        //如果包含open，则自动跳转到对应页面
                        that.openToPageByOpenMsg(getData.open);
                    }else if (getData.from){
                        //防止新手弹窗
                        localStorage.setItem("noviceGuide"+user.id,true);
                        //如果包含from，则自动跳转到对应功能页面,并添加参数
                        that.openToPageByFromMsg(getData.from,getData.data);
                    }else {
                        //验证通过后需要跳转任务列表
                        that.openToPageByOpenMsg("addCloud");
                    }
                    callback(user);
                } else {
                    callback(null);
                }
                return;
            }, error => {
                return;
            });
        } else {
            var localUser = this.getUserToLocal();
            var cookieUser = this.getUserCookies();
            if (localUser&&!cookieUser) {
                this.setUserCookies(localUser);
                callback(localUser);
                return;
            } else if(!localUser&&cookieUser) {
                this.setUserToLocal(cookieUser);
                callback(cookieUser);
            } else if(localUser&&cookieUser) {
                var newUser = localUser.lastTime>cookieUser.lastTime?localUser:cookieUser;
                this.setUserToLocal(newUser);
                this.setUserCookies(newUser);
                callback(newUser);
            } else {
                callback(null);
            }
        }

    },
    //保存用户信息到本地缓存
    setUserToLocal(user) {
        let encodeUser = JSON.parse(JSON.stringify(user));
        if(user&&user.email&&(user.email.lastIndexOf("@")>0)){
            let _key = commonstate.ENCRYPT_KEY;
            encodeUser.email = Utils.strAESKeyEncrypt(encodeUser.email,_key);
        }
        localStorage.setItem("user", JSON.stringify(encodeUser));
    },
    //获取用户信息到本地缓存
    getUserToLocal() {
        var user = JSON.parse(localStorage.getItem("user"));
        let _key = commonstate.ENCRYPT_KEY;
        if(user&&user.email){
            let email = Utils.strAESKeyDecrypt(user.email,_key);
            if(email) {
                user.email = email;
            }
        }
        return user;
    },
    //保存用户信息到Cookie
    setUserCookies(user) {
        let encodeUser = JSON.parse(JSON.stringify(user));
        if(user&&user.email&&(user.email.lastIndexOf("@")>0)){
            let _key = commonstate.ENCRYPT_KEY;
            encodeUser.email = Utils.strAESKeyEncrypt(encodeUser.email,_key);
        }
        $cookies.set("user", JSON.stringify(encodeUser),"7d");
    },
    //保存用户信息到Cookie
    getUserCookies() {
        var user = $cookies.get('user');
        let _key = commonstate.ENCRYPT_KEY;
        if(user&&user.email){
            let email = Utils.strAESKeyDecrypt(user.email,_key);
            if(email) {
                user.email = email;
            }
        }
        return user;
    },
    //通过邮箱获取信任码
    getTrustedDeviceByEmail(email) {
        var tdJson = localStorage.getItem("trustedDevice");
        if(tdJson&&email){
            var tds = JSON.parse(tdJson);
            var tdKeys = Object.keys(tds);
            let _key = commonstate.ENCRYPT_KEY;
            var td;
            for (let i = 0; i < tdKeys.length; i++) {
                const keyEmail = Utils.strAESKeyDecrypt(tdKeys[i],_key);
                if(keyEmail == email){
                    td = tds[tdKeys[i]];
                    return;
                }
            }
            if(td){
                return td;
            }
        }
        return false;
    },
    //判断用户类型，初始化按钮
    createPayBtn(user, deriction) {
        var btnTxt;
        var btnImg;
        deriction.btnColor = '';
        if (user.vip) {
            if (user.payLevel > 1) {
                btnImg = 'cartImg';
                btnTxt = deriction.$t('language.rightTopBanner.purTraffic');
            } else {
                deriction.btnColor = 'grey';
                btnImg = 'unlimitImg';
                btnTxt = deriction.$t('language.rightTopBanner.unlimitedPlan');
                if (user.payType == 'Lifetime') {
                    btnTxt = deriction.$t('language.rightTopBanner.lifeTimePlan');
                }
            }
        } else {
            if (!user.totalBytes && !user.usedBytes) {
                deriction.btnColor = 'grey';
            }
            btnImg = 'cartImg';
            btnTxt = deriction.$t('language.rightTopBanner.upgrade');
        }
        deriction.payBtn['txt'] = btnTxt;
        if (btnImg) {
            deriction.payBtn['img'] = btnImg;
        }
    },
    //封装待处理的临时任务数据
    packageDetailData(fromItemArr, toItems, remove) {
        $.each(fromItemArr, function (fromIndex, fromNode) {//把数据放在临时任务待执行弹窗
            $.each(toItems, function (aimIndex, aimNode) {
                store.state.retryItems.push({//给右侧待传任务赋值
                    name: fromNode.filename,
                    sourceId: fromNode.fileId,
                    sourceToken: fromNode.driveId,
                    status: 'ready',
                    desId: aimNode.fileId,
                    desToken: aimNode.driveId,
                    desDriveType: aimNode.driveType,
                    aimPid: aimNode.pid,
                    sourcePid: fromNode.pid,
                    remove: remove,
                    sourceCloudType: fromNode.driveType
                });
                store.state.detailedProgrssData.push({//给临时任务详情赋值
                    sourceFilename: fromNode.filename,
                    sourceNode: fromNode.nodes,
                    sourceId: fromNode.fileId,
                    desNode: aimNode.nodes,
                    desDriveType: aimNode.driveType,
                    status: 0,
                    errorList: [],
                    sourceToken: fromNode.driveId,
                    desId: aimNode.fileId,
                    desToken: aimNode.driveId,
                    sharePath: fromNode.sharePath,
                    sourceCloudType: fromNode.driveType
                });
            });
        });
    },//封装后端已返回的临时任务数据
    packageHaveDataDetail(allResTasks) {
        $.each(allResTasks, function (resIndex, resItem) {//把返回的taskId给待处理任务
            //常规云盘校验和team云盘校验不同
            let sourceNodes = resItem.sourceNode;
            let desNodes = resItem.desNode;
            $.each(store.state.retryItems, function (retryIndex, retryItem) {//遍历返回的任务数据，将之前前端赋的值都给加上taskId和group_id
                if (!retryItem.taskId &&
                    (
                        (resItem.sourceId == retryItem.sourceId &&
                            resItem.sourceToken == retryItem.sourceToken) ||
                        (retryItem.sourceCloudType == 'team' &&
                            resItem.sourceCloudType == retryItem.sourceCloudType &&
                            sourceNodes[sourceNodes.length - 1].permissionId + resItem.sourceId == retryItem.sourceId) ||
                        (retryItem.sourceCloudType == 'Shares' &&
                            resItem.sourceCloudType == retryItem.sourceCloudType &&
                            sourceNodes[1].fileId + resItem.sourceFilename == retryItem.sourceId)
                    ) &&
                    (
                        (resItem.desId == retryItem.desId &&
                            resItem.desToken == retryItem.desToken) ||
                        (retryItem.desDriveType == 'team' &&
                            resItem.desCloudType == retryItem.desDriveType &&
                            desNodes[desNodes.length - 1].permissionId + resItem.desId == retryItem.desId)
                    ) &&
                    resItem.sourceFilename == retryItem.name) {
                    retryItem.taskId = resItem.taskId;
                    if (resItem.group_id) {
                        retryItem.group_id = resItem.group_id;
                    }
                    return false;
                }
            });
            //遍历返回的任务数据，将之前前端详情赋的值都给加上taskId
            $.each(store.state.detailedProgrssData, function (detailIndex, detailItem) {
                if (!detailItem.taskId &&
                    (
                        (resItem.sourceId == detailItem.sourceId &&
                            resItem.sourceToken == detailItem.sourceToken) ||
                        (detailItem.sourceCloudType == 'team' &&
                            resItem.sourceCloudType == detailItem.sourceCloudType &&
                            sourceNodes[sourceNodes.length - 1].permissionId + resItem.sourceId == detailItem.sourceId) ||
                        (detailItem.sourceCloudType == 'Shares' &&
                            resItem.sourceCloudType == detailItem.sourceCloudType &&
                            sourceNodes[1].fileId + resItem.sourceFilename == detailItem.sourceId)
                    ) &&
                    (
                        (resItem.desId == detailItem.desId &&
                            resItem.desToken == detailItem.desToken) ||
                        (detailItem.desDriveType == 'team' &&
                            resItem.desCloudType == detailItem.desDriveType &&
                            desNodes[desNodes.length - 1].permissionId + resItem.desId == detailItem.desId)
                    ) &&
                    resItem.sourceFilename == detailItem.sourceFilename) {
                    detailItem.taskId = resItem.taskId;
                    return false;
                }
            });
        });
    },
    //根据addData清除还未创建成功，但已添加到列表的临时任务信息
    removeDataDetail(allResTasks) {
        $.each(allResTasks.fromItems, function (fromIndex, fromItem) {
            $.each(allResTasks.toItems, function (toIndex, toItem) {
                $.each(store.state.retryItems, function (retryIndex, retryItem) {
                    if (retryItem.sourceToken == fromItem.driveId && retryItem.sourceId == fromItem.fileId && retryItem.desToken == toItem.driveId && retryItem.desId == toItem.fileId) {
                        store.state.retryItems.splice(retryIndex, 1);
                        return false;
                    }
                });
                $.each(store.state.detailedProgrssData, function (detailIndex, detailItem) {
                    if (detailItem.sourceToken == fromItem.driveId && detailItem.sourceId == fromItem.fileId && detailItem.desToken == toItem.driveId && detailItem.desId == toItem.fileId) {
                        store.state.detailedProgrssData.splice(detailIndex, 1);
                        return false;
                    }
                });
            });
        });
    },
    //临时任务根据是否存在加密id，从sourceNodes中分辨出sharePath并附加tokenId，name和fileType（路径必然是文件夹）
    getSharePathForCryptId(itemDetail) {
        let nodes = itemDetail.sourceNode.filter(function (v) { return v.cryptId && v.cryptId !== "null" });
        let tokenId = itemDetail.sourceToken;
        for (let i = nodes.length - 1; i > 0; i--) {
            nodes[i].fileType = "folder";
            nodes[i].name = nodes[i].filename;
            nodes[i].tokenId = tokenId;
        }
        return nodes;
    },
    //准备三个工具方法，用于判断是否是对象类型，是否是数组，获取对象长度
    isObj(object) {
        return object && typeof (object) == 'object' && Object.prototype.toString.call(object).toLowerCase() == "[object object]";
    },
    isArray(object) {
        return object && typeof (object) == 'object' && object.constructor == Array;
    },
    getLength(object) {
        var count = 0;
        for (var i in object) count++;
        return count;
    },
    Compare(a, b) {
        let objA = Object.assign({}, a);
        let objB = Object.assign({}, b);
        delete objA.overTime;//删除对比干扰项目
        delete objB.overTime;
        delete objA.password;
        delete objB.password;
        delete objA.createTime;
        delete objB.createTime;
        delete objA.upShellTime;
        delete objB.upShellTime;
        delete objA.viewTime;
        delete objB.viewTime;
        delete objA.loginTime;
        delete objB.loginTime;
        delete objA.login72Time;
        delete objB.login72Time;
        if (!objA.vip) {
            objA.vip = false;
        }
        if (!objA.payLevel) {
            objA.payLevel = 0;
        }
        if (!this.isObj(objA) || !this.isObj(objB)) return false; //判断类型是否正确
        if (this.getLength(objA) != this.getLength(objB)) return false; //判断长度是否一致
        return this.CompareObj(objA, objB, true);//默认为true
    },
    //比较两个json对象是否相等，如果不相等则说明user发生了改变。
    CompareObj(objA, objB, flag) {
        for (var key in objA) {
            if (!flag) //跳出整个循环
                break;
            if (!objB.hasOwnProperty(key)) { flag = false; break; }
            if (!this.isArray(objA[key])) { //子级不是数组时,比较属性值
                if (objB[key] != objA[key]) { flag = false; break; }
            } else {
                if (!this.isArray(objB[key])) { flag = false; break; }
                var oA = objA[key], oB = objB[key];
                if (oA.length != oB.length) { flag = false; break; }
                for (var k in oA) {
                    if (!flag) //这里跳出循环是为了不让递归继续
                        break;
                    flag = this.CompareObj(oA[k], oB[k], flag);
                }
            }
        }
        return flag;
    },
    getAuthor(xcd) {
        var author = "Common";
        if (xcd) {
            var reg = /MC|Comnena|Ioi|Yveline|Vera|Sara|Zola|Jade|Hannah|Nancy|Delores|Maggie|Yuki|Rebecca|KDA|qd_zjt|qd_lmj|qd_yjc|qd_xj|Zoe|Holiday|Ricardo|qd_hhq|Luisa|Haru|qd_lwc/;
            if (reg.test(xcd)) {
                author = xcd.substring(xcd.indexOf("=") + 1, xcd.indexOf("&"));
            }
        }
        return author;
    },
    getPage(xcd) {
        var page;
        if (xcd) {
            page = xcd.substring(xcd.lastIndexOf("=") + 1, xcd.length);
        }
        if (page) {
            page = page.replace("home.html", "");
        } else {
            page = "/";
        }
        return page;
    },
    getDevId() {
        var devId;
        var cookies = this.fileredCookies("dev_id_");
        if(cookies&&cookies.length>0){
            devId = cookies[0].substring(7);
        }
        if(!devId){
            var ll_lp = decodeURIComponent($cookies.get("_ll_lp"));
            devId = ll_lp?ll_lp.split('_?')[1]:"";
        }
        if(!devId) {
            devId = "null";
        }
        return devId;
    },
    fileredCookies(name) {
        var cookies = document.cookie; // 获取所有的cookies
        var filteredCookies = []; // 存放过滤后的结果
        
        $.each(cookies.split('; '), function (index, value) {
            if (value.indexOf(name) === 0) {
                let parts = value.split('=');
                filteredCookies.push(parts[0]);
            }
        });
        return filteredCookies;
    },
    createXLink(author, page) {
        var lang = this.getLocaleTo(localStorage.getItem("locale"));
        var xLang = lang.substring(lang.indexOf("-") + 1).toLowerCase();
        if ("us" == xLang) {
            xLang = "en";
    }
    var link="MC_"+xLang+"-null_"+page+":"+author;
    var xReferrer = $cookies.get('x-referrer');
    if(xReferrer){
            link += "_"+xReferrer
    }
    return link;
},
//2024-10-15 添加购物车追踪并打开支付页面
addShoppingCartRecords(action,item,user,source) {
    let data = {
        ud: user.id,
        productId: item.productId,
        source: source
    }
    if(item.coupon) {
        data.coupon = item.coupon;
    }
    Utils.doSubscriptionPostRequest('add_cart_records', data).then(response => {
        if (response.message == 'success' && response.cartRecoedsId) {
            this.packageFormAndSubmit(action, item, user, response.cartRecoedsId);
        }
    });
},
//支付系统打开界面
packageFormAndSubmit(action,item,user,cartId){
    let lang = this.getLocaleTo(localStorage.getItem("locale"));
    // 创建Form
    var form = $('<form></form>');
    // 设置属性
    form.attr('action', action);
    form.attr('method', 'post');
    // form的target属性决定form在哪个页面提交
    // _self -> 当前页面 _blank -> 新页面
    let webType = this.judgeClient();
    if(webType != "IOS"){
        form.attr('target', '_blank');
    }
    // 创建Input
    var xcd = $cookies.get('x-cd');
    var author = this.getAuthor(xcd);
    var page = this.getPage(xcd);
    xcd = "cd1="+author+"&cd2="+page;
    var devId = this.getDevId();
    var xlink = this.createXLink(author, page);
    var xid = $cookies.get('x-xid');

    var extset_input;
    if(devId){
        extset_input += '<input style="hidden" name="x-devId" value="'+devId+'" />';
    }
    if(xid){
        extset_input += '<input style="hidden" name="x-xid" value="'+xid+'" />';
    }
    var extsetCookies = this.fileredCookies("___amga_");
    if(extsetCookies.length>0){
        extsetCookies.forEach(c => {
            var name = c.split('___amga_')[1];
            if(name){
                extset_input += '<input style="hidden" name="x-extset_'+name+'" value="'+$cookies.get(c)+'" />';
            }
        });
    }

    //渠道注册用户特殊处理
    if(user&&commonstate.channelTypeList.includes(user.loginType)){
        item.xPage = user.loginType;
    }

    //网红活动注册用户特殊处理
    if(user&&user.loginType) {
        let prefix = user.loginType.substring(0,8);
        if(prefix=="YouTube:") {
            let page = user.loginType.slice(8);
            item.xPage = page;
        }
    }

    //兑换码用户特殊处理
    if(user&&user.vip&&user.subscrId.slice(0, 2) === "LS") {
      //获取兑换码
      const ls = user.subscrId.slice(2, user.subscrId.length-12);
      if(ls === 'BAAYK667N5K3K0N6') {
        item.xPage = 'giveawayD';
      }
      if(ls === 'SHAREWARE06ONSAL') {
        item.xPage = '2026-hy-swo';
      }
      if(ls === 'BAAYK8Q4M7N2R6P9') {
        item.xPage = '2026-hy-08';
      }
      if(ls === 'GIVEAWAYOFTHEDAY') {
        item.xPage = '2026-hy-god';
      }
    }

    var my_input = $(
    '<input style="hidden" name="cart" value="'+item.productId+'" />'+
    '<input style="hidden" name="x-mb" value="'+item.xMb+'" />'+
    '<input style="hidden" name="x-gurantee" value="'+item.xMb+'" />'+
    '<input style="hidden" name="x-userid" value="'+user.id+'" />'+
    '<input style="hidden" name="x-level" value="'+item.xLevel+'" />'+
    '<input style="hidden" name="x-cd" value="'+xcd+'" />'+
    '<input style="hidden" name="x-link" value="'+xlink+'" />'+
    '<input style="hidden" name="x-page" value="'+item.xPage+'" />'+
    '<input style="hidden" name="x-version" value="new" />'+
    '<input style="hidden" name="coupon" value="'+item.coupon+'" />'+
    '<input style="hidden" name="x-crid" value="'+cartId+'" />'+
    extset_input);
    // 附加到Form
    form.append(my_input);
   $(document.body).append(form);
    // 提交表单
    form.submit();
    this.send_ll_lp();
    // 注意return false取消链接的默认动作
    return false;
},
//2023-12-11新增营销追踪
send_ll_lp() {
    var ll_lp = decodeURIComponent($cookies.get("_ll_lp"));
    // var newV = ll_lp?ll_lp.split('_?')[1]:"";
    // var oldV = localStorage.getItem('_ll_lp');
    // if(ll_lp && newV && newV != 'undefined' && newV != oldV){
        var url = "https://www.multcloud.com/ss/qgv1.png";
        var data = {
            lp: ll_lp,
            ga: $cookies.isKey("_ga")?$cookies.get("_ga"):'',
            xid: $cookies.isKey("_ll_xid")?$cookies.get("_ll_xid"):''
        }
        Utils.doWebPostRequest(url, data);
        // new Promise((resolve, reject) => {
        //     axios.post(url, data).then(response => {
        //         // localStorage.setItem('_ll_lp',newV);
        //     }, err => {
        //         reject(err);
        //     });
        // })
    // }
},
    //打开通知窗口
    getNotifications(that) {
        that.newNotifyShow = false;
        let user = this.getUser();
        let check = that.$cookies.get('check' + user.id);
        if (check != 'true' && check != true) {
            check = false;
        }
        if (that.$refs.notificationsDialog && that.$refs.notificationsDialog.versions.length) {
            that.$refs.notificationsDialog.notificationsShow = true;
            that.$refs.notificationsDialog.contentShow = true;
            that.$refs.notificationsDialog.check = check;
            this.updateViewTime();
        } else {
            Utils.doNotifyRequest("get_version_info", {
                ud: this.getUser().id
            }).then(result => {
                if (result.status == 200) {
                    let versions = result.versions;
                    that.$refs.notificationsDialog.timejson = versions.splice(0, 1);
                    that.$refs.notificationsDialog.versions = versions;
                    that.$refs.notificationsDialog.notificationsShow = true;
                    that.$refs.notificationsDialog.contentShow = true;
                    that.$refs.notificationsDialog.check = check;
                    this.updateViewTime();
                }
            });
        }
    },
    isDemoUser() {
        let user = this.getUser();
        return user.email == "demo@multcloud.com";
    },
    updateViewTime() {
        let user = this.getUser();
        let nowDateLong = new Date().getTime();//现在时间
        //对后台viweTime进行修改
        let changeData = {
            ud: user.id,
            viewTime: nowDateLong,
        }
        Utils.doUserHaveLoginRequest("update", changeData).then(res => {
            if (res.status == 200) {
                user.viewTime = nowDateLong;
                this.setUserToLocal(user);
            }
        });
    },
    getRealTimeModel() {
        //筛选出只支持即时同步的云盘
        let models = Object.assign([], store.getters.getUsersDrives);
        let supportsRealTimeArr = [];
        $.each(models, function (i, item) {
            if (commonstate.supportRealTimeDrives.includes(item.appName)) {
                supportsRealTimeArr.push(item);
            }
        });
        return supportsRealTimeArr;
    },
    //退出时清除缓存
    logout_clear() {
        var user = this.getUser();
        var td = localStorage.getItem("trustedDevice");
        var psd = localStorage.getItem(user.id + 'interimPsd');
        var hallShow = localStorage.getItem('halloweenSale' + user.id);
        var normalPayUpgrade = store.state.normalPayUpgrade;
        $cookies.remove("familyDaySaled" + user.id);
        //清除用户信息
        var cookieUser = $cookies.get("user");
        if(cookieUser&&cookieUser.salt==user.salt){
            //同一登录的同一账号才需要清除缓存
            $cookies.remove("user");
        }
        window.localStorage.clear();
        //存在trustedDevice时，不清除
        if (td) {
            localStorage.setItem("trustedDevice", td);
        }
        if (psd) {
            localStorage.setItem(user.id + "interimPsd", psd);
        }
        //如果是付费用户且不是通过普通购买则只弹出一次
        if (user.vip && hallShow && !normalPayUpgrade) {
            localStorage.setItem('halloweenSale' + user.id, "show");
        }
    },
    //通过open字段判断跳转到哪一个页面
    openToPageByOpenMsg(open) {
        switch (open) {
            case "task":
                store.commit('setleftbannerClick', -1);
                store.commit('setleftbannerMenuClick', 100);
                break;
            case "savedShare":
                store.commit('setleftbannerClick', -1);
                store.commit('setleftbannerMenuClick', 106);
                store.commit("setSharesType", 1);
                break;
            case "addCloud":
                store.commit('setleftbannerClick', -1);
                store.commit('setleftbannerMenuClick', 901);
                break;
            default:
                break;
        }
    },
    //通过From字段判断跳转到哪一个页面
    openToPageByFromMsg(from,data) {
        switch (from) {
            case "https://insdownloader.com":
                store.commit("setTabCategories", 2);
                store.commit('setleftbannerClick', -1);
                store.commit('setleftbannerMenuClick', 201);
                store.commit('setDataFromOtherAction', '');
                break;
            case "https://easysavevideo.com":
                store.commit("setTabCategories", 3);
                store.commit('setleftbannerClick', -1);
                store.commit('setleftbannerMenuClick', 301);
                store.commit('setDataFromOtherAction', '');
                break;
            default:
                break;
        }
        if(data) {
            store.commit('setDataFromOtherAction', data);
        }
    },
    //分享页跳转到mc页面内部，open指向指定单元
    shareJumpToMcPorject(direction, open) {
        let user = this.getUser();
        if (user) {
            var json = {
                'ud': user.id,
                'salt': user.salt,
                'language': this.caseIndexLanguage(),
                'open': open,
            }
            //获取设备信任码
            var tdJson = localStorage.getItem("trustedDevice");
            if (tdJson) {
                var td = this.getTrustedDeviceByEmail(user.email);
                if (td) {
                    json.tdcode = td;
                }
            }
            var s = window.btoa(JSON.stringify(json));
            window.open(commonstate.addCloudUrl + "?callBack=" + s, '_blank');
        } else {
            direction.$toast({
                text: direction.$t('language.exception.saltInvalid'),
                type: 'fail',
                idValue: "share_page",
            });
        }
    },
    //活动用,判断是否超过时间
    getTimerExpired(t) {
        //标准日期格式转成Long型"2021-12-31 23:59:59"
        let nextTimeLong = new Date(t.replace(new RegExp("-", "gm"), "/")).getTime();
        let nowTimeLong = new Date().getTime();
        var time = nextTimeLong - nowTimeLong;
        return time > 0;
    },
    //活动用,获取剩余时间
    getTimer(t) {
        //标准日期格式转成Long型"2021-12-31 23:59:59"
        var nextTimeLong = new Date(t.replace(new RegExp("-", "gm"), "/")).getTime();
        let nowTimeLong = new Date().getTime();
        var time = Math.ceil((nextTimeLong - nowTimeLong) / 100) * 100;
        return time;
    },
    //storage模糊删除
    removeStorageLike(name) {
        for (var k in sessionStorage) {
            if (k.indexOf(name) > -1)
                localStorage.removeItem(k);
        }
    },
    //路径如果存在备份根目录，则返回true，此时不再缓存
    pathExcludeBackupRoot(path) {
        if (path) {
            for (var i = 0; i < path.length; i++) {
                if (path[i].name == "MultCloud Cloud Backup") {
                    return true;
                }
            }
        }
    },
    //获取用户当前订单信息和可购买订单信息
    getUserSchemeForPsySys(userId) {
        Utils.doSubinquiryPostRequest('get_by_user', { ud: userId }).then(res => {
            store.commit("setPaySysRes", res);
        })
    },
    //初始化价格格式
    initPriceFormat(type, value) {
        value = value.toString();
        var price = value.split('.');
        var num;
        var point;
        //获取整数位，最低为0
        num = price[0];
        if (num.length > 3) {
            let nums = [];
            //从倒数第三位后开始添加分隔
            let i = num.length - 3;
            //小于0无需添加分隔
            while (i >= 0) {
                nums.splice(0, 0, num.substr(i, 3));
                i = i - 3;//每三位分隔
            }
            //添加未满三位的头部字符串
            nums.splice(0, 0, num.substring(0, i + 3));
            num = nums.join(",");
        }
        //如果有小数位，获取小数位
        if (price.length > 1) {
            point = price[1];
            if (type == "EUR") {
                //欧元特殊处理
                return num + "," + point;
            }
            return num + "." + point;
        } else {
            return num;
        }
    },
    //判断是否是游客账号
    testUserIsTourist(user) {
        //用户不是子账号或第三方登录并且不符合邮箱登录格式
        if (!user.loginType &&user.email&& !commonstate.emailpattern.test(user.email)) {
            return true;
        }
        return false;
    },
    /*判断客户端*/
    judgeClient() {
        let u = navigator.userAgent;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.match(/mobile/i);   //判断是否是 android终端

        if (isIOS) {
            return 'IOS';
        } else if (isAndroid) {
            return 'Android';
        } else {
            return 'PC';
        }
    },
    //获取当前用户的所有活动标签信息，并缓存
    getAllActiveTagByUser() {
        let that = this;
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        Utils.doAcvieTagRequest("get_by_user", { ud: this.getUser().id,timezone:userTimeZone}).then(res => {
            if (res.code == 200) {
                if (res.data) {
                    store.commit("setActiveTags", res.data);
                }
            } else if(res.reason == "saltInvalid"){
                return;
            } else {
                //3s后再次请求
                setTimeout(() => {
                    that.getAllActiveTagByUser();
                }, 3000);
            }
        });
    },

    //保存一个标签，永久保存
    saveActiveTagByUser(direction, name, val) {
        let that = this;
        let date = {
            ud: this.getUser().id,
            tag: name,
            message: val,
        };
        Utils.doAcvieTagRequest("save_tag", date).then(res => {
            if (res.code == 200) {
                //更新信息
                that.getAllActiveTagByUser();
            } else if (res.code == 400 && res.reson) {
                direction.$toast({
                    text: direction.$t('language.exception.' + res.reson),
                    type: 'fail',
                    idValue: "rightBo",
                });
            } else {
                direction.$toast({
                    text: 'Unknown error!',
                    type: 'fail',
                    idValue: "rightBo",
                });
            }
        });
    },
    //缓存中获取某个标签信息
    getActiveTagByStore(name) {
        let tags = store.getters.getActiveTags;
        let newTag = [];
        if (tags && tags.length > 0) {
            newTag = tags.filter((tag) => {
                return tag.activeTag === name;
            })
        }
        if(newTag.length>0){
            return newTag;
        }else {
            return false;
        }
    },
    // 更新图片保存目的地
    updateImageSaverDestNode(node) {
        store.state.imageSaverDestNode = node;
    },
    // 更新所有图片保存任务
    updateImageSaverTasks(tasks) {
        store.state.imageSaverTaskDatas = tasks;
    },
    // 增加图片保存任务
    addImageSaverTask(items) {
        var tasks = store.state.imageSaverTaskDatas;
        if (items.length == 1) {
            var hasTask = false;
            var curId = items[0].id;
            for (var i=0; i<tasks.length; i++) {
                if (tasks[i].id == curId) {
                    hasTask = true;
                    break;
                }
            }
            if (!hasTask) {
                tasks.unshift(items[0]);
            }
        } else {
            // 不会有这种情况
            tasks = tasks.concat(items);
        }
    },
    // 多语言日期格式化
    i18nDateFormat(timestamp, language) {
        // 指定日期时间
        const now = new Date(timestamp);
        // 24小时制
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        // 12小时制
        let hours12 = now.getHours();
        const ampm = hours12 >= 12 ? 'PM' : 'AM';
        hours12 = hours12 % 12;
        hours12 = hours12 ? hours12 : 12;
        hours12 = String(hours12).padStart(2, '0');
        // 德语
        if (language == 'deutsch') {
            return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
        }
        // 法语、西班牙语、意大利语、葡萄牙语
        if (language=='france' || language=='spanish' || language=='italian' || language=='portuguese') {
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        }
        // 荷兰语
        if (language == 'nederlands') {
            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        }
        // 日语、繁体中文、简体中文
        if (language=='japanese' || language=='traditionalChinese' || language=='chinese') {
            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
        }
        // 默认英语
        return `${month}/${day}/${year} ${hours12}:${minutes}:${seconds} ${ampm}`;
    },
}



// WEBPACK FOOTER //
// ./src/js/workspace/common_util.js